import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ToastElement from '../../../../Components/UiComponents/ToastElement';
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import { Accordion, AccordionTab } from 'primereact/accordion';
// Services
import _ from 'lodash';
import Loader from '../../../../Components/UiComponents/Loader';
import { getProjectNumber } from '../../../../Services/opportunityService';
import { get as cusGet } from '../../../../Services/customerServices';
import { Tooltip } from 'primereact/tooltip';
import { useForm, Controller } from 'react-hook-form';
import SingleSelectElement from '../../../../Components/UiComponents/SingleSelectElement';
import { getCustomerDetails, getCustomerTable, filter as fil } from '../../../../Services/clientService';
import filter from 'lodash/filter';
import DropdownElement from "../../../../Components/UiComponents/DropdownElement";
import RadioElement from '../../../../Components/UiComponents/RadioElement';
import TextareaElement from "../../../../Components/UiComponents/TextareaElement";
import { getUsersList } from '../../../../Services/userService';
import CalendarElement from '../../../../Components/UiComponents/CalendarElement';
import InputTextElementElement from '../../../../Components/UiComponents/InputTextElement';
import { getModulePermissions } from '../../../../Services/pricingPlanService';
import { Dialog } from 'primereact/dialog';
import { generateTenderSalesReport, generateTenderDocumentReviewReport } from "../../../../Services/opportunityService";
import moment from "moment";
import { downloadDocs } from '../../../../Services/opportunityService';
import { useOpportunity } from "../../../../Providers/OpportunityContext";
import AutoCompleteElement from '../../../../Components/UiComponents/AutoCompleteElement';
import { api } from '../../../../Apis/interceptor';
import MultiSelectElement from '../../../../Components/UiComponents/MultiSelectElement';
import PlaylistVideos from '../../../../Components/Videos/PlaylistVideos';

const Summary = ((props) => {
    const { opportunityId } = useParams();
    const { globalOpportunityData, setGlobalOpportunityData } = useOpportunity();
    const { formState: { errors }, setValue, getValues, control } = useForm();
    const [userId, setUserId] = useState(null);
    const [customer, setCustomer] = useState(null);
    const [customerId, setCustomerId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [newModule, setNewModule] = useState({});
    const [opportunityDetails, setOpportunityDetails] = useState({});
    const toastRef = useRef();
    const [projectNumber, setProjectNumber] = useState();
    const [projectNumAlertModal, setProjectNumAlertModal] = useState(false);
    const [disableGenerate, setDisableGenerate] = useState(true);
    const [customerTooltipData, setCustomerTooltipData] = useState();
    const [servicesType, setServicesType] = useState();
    const [customerDetails, setCustomerDetails] = useState({});
    const [custDetails, setCustDetails] = useState({});
    const [clientFieldsNew, setClientFieldsNew] = useState();
    const [statusPrivilege, setStatusPrivilege] = useState();
    const [showModal, setShowModal] = useState(false);
    const [isStop, setIsStop] = useState(true);
    const [pendingStatus, setPendingStatus] = useState(null);
    const [bidLeaderList, setBidLeaderList] = useState();
    const [customerTable, setCustomerTable] = useState(null);
    const [editData, setEditData] = useState();
    const [commercialData, setCommercialData] = useState();
    const [currency, setCurrency] = useState();
    const [sectionPermissions, setSectionPermissions] = useState();
    const [tabPermissions, setTabPermissions] = useState();
    const [pricingPlan, setPricingPlan] = useState();
    const [stakeHolderDetails, setStakeHolderDetails] = useState([]);
    const [client, setClient] = useState({});
    const [bidTeamUpdateAlertModal, setBidTeamUpdateAlertModal] = useState(false);
    const [newBidTeam, setNewBidTeam] = useState({});
    const [bidOptions, setBidOptions] = useState([]);
    const [selectedAssociatedClient, setSelectedAssociatedClient] = useState('');
    const [associatedDataClient, setAssociatedDataClient] = useState([])
    const [cliRes, setCliRes] = useState([])
    const [projectAddressText, setProjectAddressText] = useState("");
    const [projectCoordinates, setProjectCoordinates] = useState("");
    const [regionsText, setRegionsText] = useState("");
    const [regions, setRegions] = useState([]);
    const [noResults3, setNoResults3] = useState(false);
    const [radio, setRadio] = useState("");
    const [selectedFramework, setSelectedFramework] = useState('');
    const [frameworkData, setFrameworkData] = useState([]);
    const [showVideo, setShowVideo] = useState(false);
    const navigate = useNavigate()

    const userprivileges = localStorage.getItem("user_privileges");
    if (userprivileges) {
        const tmpPrivilege = JSON.parse(userprivileges);
        if (tmpPrivilege !== undefined && tmpPrivilege !== null) {
            var contract_summary = tmpPrivilege[0].contract;
            var commercial_summary = tmpPrivilege[0].commercial;
        }
    }

    useEffect(() => {
        if (props?.customerId) {
            getCustomer();
            option();
            getCustomerDetail();
            getBidLeaderList();
            getCustomerTableInfo();
        }
    }, [props?.customerId]);
    useEffect(() => {
    }, [opportunityDetails]);

    useEffect(() => {
        if (opportunityDetails?.opportunity_name) {
            setValue("opportunity_name", opportunityDetails.opportunity_name);
        }
    }, [opportunityDetails, setValue]);

    useEffect(() => {
        if (props.opportunityData) {
            setOpportunityDetails(props.opportunityData)
        }
        addBidLeaderToTeam();
        getStatkeHolderDetails()
    }, [props.opportunityData])

    const addBidLeaderToTeam = async () => {
        if(props.opportunityData?.bid_Leader_id){
            if(!props.opportunityData.ie_bid_team.internal_bid_team?.some(user => user.user_id === props.opportunityData.bid_Leader_id)){
                const response = await getUsersList(props.customerId, props.branch);
                const bid_leader = _.find(response.data, { _id: props.opportunityData.bid_Leader_id});
                const newBidLeaders = {
                    role: bid_leader.role_name,
                    bid_team_role: "Project Leader",
                    team_member: props.opportunityData.bid_Leader,
                    user_id: bid_leader._id,
                    hourly_rate: bid_leader.hourlyrate,
                };
                setOpportunityDetails((prevOpportunityDetails) => ({
                    ...prevOpportunityDetails,
                    ['ie_bid_team']: {
                        ...prevOpportunityDetails['ie_bid_team'],
                        ['internal_bid_team']: [
                            ...prevOpportunityDetails['ie_bid_team']['internal_bid_team'],
                            newBidLeaders
                        ]
                    }
                }));
            }           
        }
    } 

    useEffect(() => {
        if (props.stageIndex >= 2 && _.isUndefined(opportunityDetails?.project_number))
            setDisableGenerate(false);
        else
            setDisableGenerate(true);
    }, [props.stageIndex])

    useEffect(() => {
        setGlobalOpportunityData((prevData) => ({
            ...prevData,
            ...opportunityDetails,
        }));

    }, [opportunityDetails]);

    useEffect(() => {
        const fetchEndUserData = () => {
            const enduserStr = localStorage.getItem("enduser");

            if (enduserStr) {
                try {
                    // Parsing end user data
                    const enduser = JSON.parse(enduserStr);

                    if (enduser) {
                        try {
                            setCustomer(enduser);
                            setUserId(enduser.userid || null);
                            setCustomerId(enduser.customer || null);

                            // Ensure user_privileges exists and has elements before accessing
                            const privileges = enduser.user_privileges?.[0];
                            setStatusPrivilege(privileges?.bid_status_edit || false);
                        } catch (error) {
                            // Show toast notification for parsing errors
                            toastRef.current.showToast({
                                type: 'error',
                                message: "Error. Please try again or contact Admin"
                            });
                        }
                    }
                } catch (error) {
                    // Show toast notification for parsing errors
                    toastRef.current.showToast({
                        type: 'error',
                        message: "Error parsing end-user data. Please try again or contact Admin"
                    });
                }
            } else {
                navigate("/login")
                localStorage.clear()
            }
        };

        fetchEndUserData();
    }, [opportunityId]);

    useEffect(() => {
        // To auto populate form
        if (opportunityDetails && client && stakeHolderDetails)
            getEditData(opportunityDetails, client, stakeHolderDetails);
        setSelectedFramework(opportunityDetails.opportunity?.framework_name || '')
        setRegionsText(opportunityDetails.additional?.region || '')

    }, [opportunityDetails, client, stakeHolderDetails]);

    useEffect(() => {
        if (bidLeaderList && opportunityDetails) {
            getCommercialData();
        }
    }, [opportunityDetails, bidLeaderList])

    useEffect(() => {
        getModulePermission();
    }, [pricingPlan])

    useEffect(() => {
        if (selectedAssociatedClient) {
            setOpportunityDetails((prevData) => ({
                ...prevData,
                client_id: cliRes?.find((item) => item.client_name === selectedAssociatedClient)?._id
            }));
        }
    }, [selectedAssociatedClient, cliRes])

    useEffect(() => {
        setProjectAddressText(props.opportunityData.additional?.project_location);
    }, [props.opportunityData.additional?.project_location]);

    useEffect(() => {
        setProjectCoordinates(
            props.opportunityData?.additional?.project_coordinates
        );
    }, [props?.opportunityData?.additional?.project_coordinates]);

    useEffect(() => {
        const initializeAutocomplete = () => {
            const inputElement = document.querySelector('.project-address'); // Using class selector
            if (window.google && inputElement) {
                const autocomplete = new window.google.maps.places.Autocomplete(inputElement);

                autocomplete.addListener('place_changed', () => {
                    const place = autocomplete.getPlace();
                    if (!place.geometry) {
                        console.log("No details available for input: '" + place.name + "'");
                        return;
                    }

                    const lat = place.geometry.location.lat();
                    const lng = place.geometry.location.lng();
                    const coordinates = `${lat?.toFixed(6)}, ${lng?.toFixed(6)}`;
                    const address = place.formatted_address;

                    setProjectCoordinates(coordinates);
                    setProjectAddressText(address);

                    // Update global state with the address and coordinates
                    setOpportunityDetails((prevData) => ({
                        ...prevData,
                        additional: {
                            ...prevData.additional,
                            project_location: address,
                            project_coordinates: coordinates,
                        },
                    }));
                });
            } else {
                console.error('Google Maps or input field not available');
            }
        };

        initializeAutocomplete()

    }, [projectAddressText]);

    const getRegions = (event) => {
        const val = event?.query;
        let filtered = [];

        if (_.isEmpty(val)) {
            filtered = props.regions.slice(0, 8);
        } else {
            const lowerCaseVal = val.toLowerCase();
            filtered = props.regions.filter((item) =>
                item.label.toLowerCase().includes(lowerCaseVal)
            );
        }

        setNoResults3(filtered.length === 0);
        setRegions(filtered);
    };

    const handleGetFramework = async () => {
        const framworkResponse = await api.get("/api/v1/getFrameworks", {
            params: { cust_id: props.customerId, searchVal: selectedFramework },
        });
        const frameworkDisplayNames = framworkResponse.data.framework.map(
            (framework) => framework.framework_display_name
        );
        setFrameworkData(frameworkDisplayNames);
    };

    const getBidLeaderList = async () => {
        try {
            // Ensure customerId and branch are present before making the API call
            if (!props?.customerId || !props?.branch) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Customer ID or branch is missing.'
                });
                return;
            }

            setLoading(true);

            // Fetch users list
            const response = await getUsersList(props.customerId, props.branch);

            // check if response contains valid data
            if (response?.data) {
                setBidLeaderList(response.data);
            } else {
                // Handle case where data is missing or invalid
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Failed to retrieve the bid leader list.'
                });
            }
        } catch (error) {
            // Show user-friendly error message
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or contact Admin.'
            });
        } finally {
            setLoading(false);
        }
    };


    const getEditData = (opportunityDetails) => {
        const options = bidLeaderList?.map((type) => ({
            value: type.value,
            label: type.firstname + " " + type.surname,
            id: type._id
        }));

        if (opportunityDetails) {
            const edit = _.cloneDeep(opportunityDetails);

            if (edit.additional) {
                edit.services = client?.Services?.filter(
                    (item) => item.label === opportunityDetails?.services
                )[0];

                // edit.work_type = client?.WorkType?.filter(
                //     (item) => item.label === opportunityDetails?.summary?.work_type
                // )[0];

                // edit.form_of_contract = client?.formOfContract1?.filter(
                //     (item) => item.label === opportunityDetails?.summary?.form_of_contract
                // )[0];

                // edit.procurement_route = client?.ProcurementRoute?.filter(
                //     (item) => item.label === opportunityDetails?.summary?.procurement_route
                // )[0];

                edit.sector = client?.SectorV1?.filter(
                    (item) => item.label === opportunityDetails?.sector
                )[0];

                edit.sectorDetails = props.sector.filter(
                    (item) => item.label === opportunityDetails?.sector
                )[0];

                edit.bid_leader = options?.filter(
                    (item) => item.label === opportunityDetails?.bid_Leader
                )[0];

                edit.business_unit = client?.BusinessUnit?.filter(
                    (item) => item.label === opportunityDetails?.business_unit
                )[0];

                for (const key in stakeHolderDetails) {
                    if (stakeHolderDetails[key].client_name === opportunityDetails?.client_name) {
                        edit.client_name = {
                            label: stakeHolderDetails[key].client_name,
                            value: stakeHolderDetails[key].client_name
                        };
                    }
                }

                edit.additional.client_type = props.clientType.filter(
                    (item) => item.label === opportunityDetails?.additional.client_type
                )[0];

                edit.additional.client_classification =
                    opportunityDetails?.additional.client_classification.map((item) => {
                        return (
                            props.clientClassificationV1.find(
                                (option) => option.label === item.label
                            ) || item
                        );
                    }) || [];

                const bidValue = bidLeaderList?.map((type) => ({
                    value: type.value,
                    label: type.firstname + " " + type.surname,
                    id: type._id
                }));
                setBidOptions(bidValue);
            }
            setEditData(edit);
        }
    }

    const getCustomerTableInfo = async () => {
        try {
            // Ensuring customerId exists before making the API call
            if (!props?.customerId) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Customer ID is missing.'
                });
                return;
            }

            setLoading(true);

            // Fetching customer table info from the API
            const res = await getCustomerTable(props.customerId);

            // Check if response data is valid
            if (res?.data?.cust && res?.data?.cust.length > 0) {
                setCustomerTable(res.data.cust[0]);
            } else {
                // Handle cases where the response is empty or invalid
                toastRef.current.showToast({
                    type: 'error',
                    message: 'No customer table data found.'
                });
            }
        } catch (error) {
            // Show a user-friendly error message
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred while fetching customer table data. Please try again later.'
            });
        } finally {
            setLoading(false);
        }
    };



    const getModulePermission = async () => {
        try {
            // Ensure pricingPlan is available
            if (!pricingPlan) {
                return;
            }

            setLoading(true);

            // Fetch module permissions
            const res = await getModulePermissions(pricingPlan, "Pipeline");

            setLoading(false);

            if (res?.data) {
                const { status, sub_modules, sections } = res.data;

                // Handle sub_modules permissions
                if (status && sub_modules) {
                    const tabPermissions = sub_modules.reduce((acc, sub_module) => {
                        acc[sub_module.module_name] = sub_module.status;
                        return acc;
                    }, {});
                    setTabPermissions(tabPermissions);
                }

                // Handle sections permissions
                if (status && sections) {
                    const sectionPermissions = sections.reduce((acc, section) => {
                        acc[section.section] = section.status;
                        return acc;
                    }, {});
                    setSectionPermissions(sectionPermissions);
                }
            } else {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Failed to retrieve module permissions.'
                });
            }
        } catch (error) {
            // Show a user-friendly error message
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred while fetching module permissions. Please try again or contact Admin.'
            });
        }
    };


    const getCommercialData = async () => {
        var internalHours = 0;
        var internalCost = 0;
        var externalCost = 0;
        var totalBidCost = 0;
        var BidCost_TCV = 0;
        var projected_bid_cost = 0;
        var externalEstCost = 0;

        if (!_.isUndefined(opportunityDetails.ie_bid_team)) {
            var total = 0;
            for (var i = 0; i < opportunityDetails.ie_bid_team.internal_bid_team.length; i++) {
                var temp = opportunityDetails.ie_bid_team.internal_bid_team[i].total_actual
                    ? opportunityDetails.ie_bid_team.internal_bid_team[i].total_actual
                    : 0;
                total = parseFloat(total) + parseFloat(temp);
            }
            internalHours = total;
        }

        if (!_.isUndefined(opportunityDetails.ie_bid_team)) {
            var total = 0;
            for (var i = 0; i < opportunityDetails.ie_bid_team.internal_bid_team.length; i++) {
                var tempAct = opportunityDetails.ie_bid_team.internal_bid_team[i].total_actual
                    ? opportunityDetails.ie_bid_team.internal_bid_team[i].total_actual
                    : 0;
                var user = _.find(bidLeaderList, {
                    _id: opportunityDetails.ie_bid_team.internal_bid_team[i].user_id,
                });
                var tempHrs = 0;
                if (user) {
                    tempHrs = user.hourlyrate ? user.hourlyrate : 0;
                }
                var tmpTotal = parseFloat(tempAct) * parseFloat(tempHrs);
                total = parseFloat(total) + parseFloat(tmpTotal);
            }
            internalCost = total?.toFixed(2);
        }


        if (!_.isUndefined(opportunityDetails.ie_bid_team)) {
            var actTotal = 0;
            var estTotal = 0;
            for (var i = 0; i < opportunityDetails.ie_bid_team.external_bid_team.length; i++) {
                var temp = opportunityDetails.ie_bid_team.external_bid_team[i].actual_cost
                    ? opportunityDetails.ie_bid_team.external_bid_team[i].actual_cost
                    : 0;
                var temp1 = opportunityDetails.ie_bid_team.external_bid_team[i].estimated_cost
                    ? opportunityDetails.ie_bid_team.external_bid_team[i].estimated_cost
                    : 0;

                actTotal = parseFloat(actTotal) + parseFloat(temp);
                estTotal = parseFloat(estTotal) + parseFloat(temp1);
            }
            externalCost = actTotal;
            externalEstCost = estTotal;
        }

        totalBidCost = parseFloat(internalCost) + parseFloat(externalCost);

        var contract_value = parseFloat(opportunityDetails.total_contract_value?.text)
            ? parseFloat(opportunityDetails.total_contract_value?.text)
            : 0;
        BidCost_TCV = (contract_value == 0) ? 0 : parseFloat((totalBidCost / contract_value) * 100);


        if (!_.isUndefined(opportunityDetails.ie_bid_team)) {
            var internal_total = 0;
            for (var i = 0; i < opportunityDetails.ie_bid_team.internal_bid_team.length; i++) {
                var user = _.find(bidLeaderList, {
                    _id: opportunityDetails.ie_bid_team.internal_bid_team[i].user_id,
                });
                var tempHrs = 0;
                if (user) {
                    tempHrs = user.hourlyrate ? user.hourlyrate : 0;
                }

                var tempEstHrs = opportunityDetails.ie_bid_team.internal_bid_team[i].total_est_hours
                    ? opportunityDetails.ie_bid_team.internal_bid_team[i].total_est_hours
                    : 0;
                var tmpTotal = parseFloat(tempEstHrs) * parseFloat(tempHrs);
                internal_total = parseFloat(internal_total) + parseFloat(tmpTotal);
            }
            projected_bid_cost = parseFloat(internal_total) + parseFloat(externalEstCost);
        }

        setCommercialData({
            "internalHours": internalHours,
            "internalCost": internalCost,
            "externalCost": externalCost,
            "totalBidCost": totalBidCost,
            "BidCost_TCV": BidCost_TCV,
            "projected_bid_cost": projected_bid_cost
        });
    }

    useEffect(() => {
        if (props?.summaryData?.projectSumSections) {
            let obj1 = _.find(props?.summaryData?.projectSumSections, { section_name: "Bid Status" })?.display_name;
            let obj2 = _.find(props?.summaryData?.projectSumSections, { section_name: "Project" })?.display_name;
            let obj3 = _.find(props?.summaryData?.projectSumSections, { section_name: "Bid Team" })?.display_name;
            let obj4 = _.find(props?.summaryData?.projectSumSections, { section_name: "Contract" })?.display_name;
            let obj5 = _.find(props?.summaryData?.projectSumSections, { section_name: "Commercial" })?.display_name;
            if (contract_summary && commercial_summary) {
                let combined = { obj1, obj2, obj3, obj4, obj5 };
                setNewModule(combined)
            } else if (!contract_summary && commercial_summary) {
                let combined = { obj1, obj2, obj3, obj5 };
                setNewModule(combined)
            } else if (contract_summary && !commercial_summary) {
                let combined = { obj1, obj2, obj3, obj4 };
                setNewModule(combined)
            } else {
                let combined = { obj1, obj2, obj3 };
                setNewModule(combined)
            }
        }

    }, [props?.summaryData?.projectSumSections])


    const getCustomerDetail = async () => {
        try {
            setLoading(true);

            // Fetch customer details
            const response = await getCustomerDetails(props?.customerId);
            // Ensure response data exist
            if (response?.data?.reference_data) {
                setCustDetails(response.data)
                setCustomerDetails(response.reference_data);

                const updatedClient = {};
                const cusData = response.data.reference_data;

                cusData.forEach((item) => {
                    const activeChoices = filter(item.option_choice, { status: 'active' });

                    switch (item.option_names) {
                        case "Services":
                            updatedClient.Services = activeChoices?.map(element => ({
                                id: element._id,
                                label: element.label,
                                status: element.status,
                            })) || [];
                            break;
                        case "WorkType":
                            updatedClient.WorkType = activeChoices || [];
                            break;
                        case "FormOfContractV1":
                            updatedClient.formOfContract1 = activeChoices || [];
                            break;
                        case "ProcurementRoute":
                            updatedClient.ProcurementRoute = activeChoices || [];
                            break;
                        case "SectorV1":
                            updatedClient.SectorV1 = activeChoices?.map(element => ({
                                id: element._id,
                                label: element.label,
                                status: element.status,
                            })) || [];
                            break;
                        case "BusinessUnit":
                            updatedClient.BusinessUnit = activeChoices?.map(element => ({
                                id: element._id,
                                label: element.label,
                                status: element.status,
                            })) || [];
                            break;
                        default:
                            break;
                    }
                });

                setClient(updatedClient);
            } else {
                // Handle cases where the response is missing or invalid
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Customer reference data not found.'
                });
            }
        } catch (error) {
            // Show a user-friendly error message
            toastRef.current.showToast({
                type: 'error',
                message: 'Failed to fetch customer details. Please try again or contact Admin.'
            });
        } finally {
            setLoading(false);
        }
    };


    const getCustomer = async () => {
        try {
            // Checking if customerId exists before making the API call
            if (!props?.customerId) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Customer ID is missing.'
                });
                return;
            }
            setLoading(true);
            // Fetch customer data
            const customer = await cusGet(props.customerId);
            // Checking if the API response contains valid data
            if (customer?.data) {
                setPricingPlan(customer.data.pricing_plan || '');
                setCustomerTooltipData(customer.data?.tooltips?.pipeline?.summary || '');
                setCurrency(customer.data.currency || '');
            } else {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Failed to retrieve valid customer data. Please try again later.'
                });
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or contact Admin.'
            });
        } finally {
            setLoading(false);
        }
    };


    const getStatkeHolderDetails = async () => {
        try {
            // Check if the branch ID exists before proceeding
            if (!props.branch?.branch_id) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Branch ID is missing. Please select a branch.'
                });
                return;
            }

            // Prepare the data object for the API call
            const data = {
                skip: 0,
                limit: 'All',
                cust_id: props.customerId || '',
                branch: props.branch,
                pattern: 'All',
                sortBy: 'client_name',
                orderBy: 1,
                filterData: {
                    filter: 'All',
                    branch_id: [],
                    client_classification: [],
                    relationship_owner: [],
                    client_type: [],
                    sector: [],
                    stakeholder_status: [],
                    business_unit: [],
                    region: [],
                    main_board_sponsor: []
                }
            };

            setLoading(true);

            // Fetch stakeholder details
            const stakeholderDetail = await fil(
                data.skip,
                data.limit,
                data.cust_id,
                data.branch,
                data.pattern,
                data.sortBy,
                data.orderBy,
                data.filterData
            );

            // Handle case where no data is returned
            if (!stakeholderDetail?.data?.client) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'No stakeholder details found.'
                });
                return;
            }

            // Update the stakeholder details state
            setStakeHolderDetails(stakeholderDetail.data.client);
        } catch (error) {
            // Show a user-friendly error message
            toastRef.current.showToast({
                type: 'error',
                message: 'Failed to fetch stakeholder details. Please try again or contact Admin.'
            });
        } finally {
            setLoading(false);
        }
    };


    const parseDateString = (dateString) => {
        if (dateString != undefined && typeof dateString === 'string') {
            const [day, month, year] = dateString.split('-')?.map(Number);
            return new Date(year, month - 1, day); // Month is 0-indexed in JavaScript Date
        }
    };

    // Format the Date object to "dd-mm-yyyy" format
    const formatDate = (input) => {
        const date = (input instanceof Date) ? input : new Date(input);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const option = () => {
        setServicesType(opportunityDetails?.services)
    }

    const handleInputChange = (field, value) => {
        setOpportunityDetails((opportunityDetails) => ({
            ...opportunityDetails,
            [field]: {
                ...opportunityDetails[field],
                radio: value
            }
        }));
        setGlobalOpportunityData((prevData) => ({
            ...prevData,
            [field]: {
                ...prevData[field],
                radio: value
            }
        }));
    };

    const handleSummaryInputChange = (field1, field2, value) => {
        setOpportunityDetails((prevOpportunityDetails) => ({
            ...prevOpportunityDetails,
            [field1]: {
                ...prevOpportunityDetails[field1],
                [field2]: {
                    ...prevOpportunityDetails[field1][field2],
                    radio: value,
                },
            },
        }));
        setGlobalOpportunityData((prevGlobalOpportunityData) => ({
            ...prevGlobalOpportunityData,
            [field1]: {
                ...prevGlobalOpportunityData[field1],
                [field2]: {
                    ...prevGlobalOpportunityData[field1][field2],
                    radio: value,
                },
            },
        }));
    };


    const handleCalenderInputChange = (field, value) => {
        setOpportunityDetails((prevOpportunityDetails) => ({
            ...prevOpportunityDetails,
            [field]: {
                ...prevOpportunityDetails[field],
                text: value
            }
        }));
        setGlobalOpportunityData((prevGlobalData) => ({
            ...prevGlobalData,
            [field]: {
                ...prevGlobalData[field],
                text: value,
            },
        }));

        if (field === 'tender_due' && !_.isUndefined(opportunityDetails.tender_due_out)) {
            calctenderDuration(value, opportunityDetails.tender_due_out.text, field);
        } else if (field === 'tender_due_out' && !_.isUndefined(opportunityDetails.tender_due)) {
            calctenderDuration(opportunityDetails.tender_due.text, value, field);
        }
    };

    const calctenderDuration = (tender_due, tender_due_out, field) => {
        var opp_contract_start_date = moment(tender_due, "DD.MM.YYYY");
        var opp_contract_end_date = moment(tender_due_out, "DD.MM.YYYY");
        var totalDays = moment(opp_contract_end_date).diff(opp_contract_start_date, "days");
        const weeks = Math.floor(totalDays / 7);
        const days = totalDays % 7;
        var tender_period_text = weeks + " weeks, " + days + " days";

        var totalWeeks = moment(opp_contract_end_date).diff(opp_contract_start_date, "weeks");

        if (totalWeeks < 3) {
            var tender_period_opportunity = props.tenderPeriod[0]?.label;
        } else if (totalWeeks >= 3 && totalWeeks <= 4) {
            var tender_period_opportunity = props.tenderPeriod[1]?.label;
        } else if (totalWeeks >= 5 && totalWeeks <= 6) {
            var tender_period_opportunity = props.tenderPeriod[2]?.label;
        } else if (totalWeeks >= 6 && totalWeeks <= 7) {
            var tender_period_opportunity = props.tenderPeriod[3]?.label;
        } else if (totalWeeks >= 7 && totalWeeks <= 8) {
            var tender_period_opportunity = props.tenderPeriod[4]?.label;
        } else {
            var tender_period_opportunity = props.tenderPeriod[5]?.label;
        }

        setOpportunityDetails((prevOpportunityDetails) => ({
            ...prevOpportunityDetails,
            detail: {
                ...prevOpportunityDetails.detail,
                tender_period: {
                    ...prevOpportunityDetails.detail?.tender_period,
                    text: tender_period_text
                }
            },
            opportunity: {
                ...prevOpportunityDetails.opportunity,
                tender_period_opportunity: tender_period_opportunity
            }
        }));

        setGlobalOpportunityData((prevGlobalOpportunityData) => ({
            ...prevGlobalOpportunityData,
            detail: {
                ...prevGlobalOpportunityData.detail,
                tender_period: {
                    ...prevGlobalOpportunityData.detail?.tender_period,
                    text: tender_period_text
                }
            },
            opportunity: {
                ...prevGlobalOpportunityData.opportunity,
                tender_period_opportunity: tender_period_opportunity
            }
        }));
    }

    const handleCalenderSummaryInputChange = (field1, field2, value) => {
        setOpportunityDetails((prevOpportunityDetails) => ({
            ...prevOpportunityDetails,
            [field1]: {
                ...prevOpportunityDetails[field1],
                [field2]: {
                    ...prevOpportunityDetails[field1][field2],
                    text: value,
                },
            },
        }));
        setGlobalOpportunityData((prevOpportunityDetails) => ({
            ...prevOpportunityDetails,
            [field1]: {
                ...prevOpportunityDetails[field1],
                [field2]: {
                    ...prevOpportunityDetails[field1][field2],
                    text: value,
                },
            },
        }));

    };

    const confirmProjectNumGeneration = () => {
        setProjectNumAlertModal(true)
    }
    const generateProjNum = async () => {
        try {
            // Checking for customerId and opportunityId are available before making the request
            if (!customerId || !opportunityId) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID or opportunity ID.'
                });
                return;
            }

            setLoading(true);

            // Making the API call to get the project number
            const res = await getProjectNumber(customerId, opportunityId);

            if (res?.data?.success) {
                const projectNumber = res?.data?.project_number;

                // Update the project number and opportunity details
                setProjectNumber(projectNumber);
                setOpportunityDetails((prevOpportunityDetails) => ({
                    ...prevOpportunityDetails,
                    project_number: projectNumber
                }));
                hideProjectNumAlertDialog();
                setDisableGenerate(true);
            } else {
                // Handle error case or missing success in response
                const errorMessage = res?.data?.message || 'Failed to generate project number.';
                toastRef.current.showToast({
                    type: 'error',
                    message: `${errorMessage} Please try again.`
                });
            }
        } catch (error) {
            // Handling the unexpected errors, such as network issues
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        // Whenever opportunityDetails.bid_status changes, update the form field
        if (!_.isEmpty(opportunityDetails) && opportunityDetails?.bidStatus_comments) {
            setValue('bidStatus_comments', (opportunityDetails?.bidStatus_comments[opportunityDetails?.bid_status]) != undefined ? opportunityDetails?.bidStatus_comments[opportunityDetails?.bid_status] : '' || '');
        }
    }, [opportunityDetails?.bid_status, opportunityDetails?.bidStatus_comments, setValue]);

    const handleClick = (status) => {
        setPendingStatus(status);
        if (status === "Stop") {
            setShowModal(true);
        } else {
            setIsStop(false)
            updateOpportunityDetails(status);
        }
    };

    const updateOpportunityDetails = (status) => {
        const getUpdatedDetails = (prevDetails) => {
            const updatedDetails = { ...prevDetails };
            let updatedObject = {};

            if (!updatedDetails?.bidStatus_comments?.hasOwnProperty(status)) {
                updatedObject = {
                    ...updatedDetails.bidStatus_comments,
                    [status]: '', // new key-value pair
                };
            } else {
                updatedObject = {
                    ...updatedDetails.bidStatus_comments,
                };
            }

            updatedDetails.bid_status = status;
            updatedDetails.bid_status_display_name = status;
            updatedDetails.bidStatus_comments = updatedObject;

            if (status === "Won" || status === "Lost") {
                updatedDetails.isWonOrLoss = true;
            } else {
                updatedDetails.isWonOrLoss = false;
            }

            return updatedDetails;
        };

        setOpportunityDetails((prevDetails) => getUpdatedDetails(prevDetails));
        setGlobalOpportunityData((prevData) => getUpdatedDetails(prevData));
    };


    const handleConfirmStop = () => {
        setShowModal(false);
        setIsStop(true)
        updateOpportunityDetails("Stop");
    };

    const stopFooter = () => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement label="No" className="cancel-new-button" onClick={handleCloseModal} />
                    <ButtonElement type="submit" label="Yes" className="save-button" onClick={handleConfirmStop} />
                </div>
            </div>
        );
    };

    const handleSaveModal = () => {
        setEditData((prevData) => ({
            ...prevData,
            bid_leader: { value: undefined, label: "" }
        }))
        setOpportunityDetails((prevOpportunityDetails) => ({
            ...prevOpportunityDetails,
            ['bid_Leader_id']: opportunityDetails.bid_Leader_id || props.prevBidLeaderId,
            bid_leader: { value: undefined, label: "" }
        }));
        setGlobalOpportunityData((prevOpportunityDetails) => ({
            ...prevOpportunityDetails,
            ['bid_Leader_id']: globalOpportunityData.bid_Leader_id || props.prevBidLeaderId,
            bid_leader: { value: undefined, label: "" }
        }))
        setBidTeamUpdateAlertModal(false);

    };

    const updateBidTeam = () => {
        if (opportunityDetails.bid_Leader_id) {
            // props.prevBidLeaderId = opportunityDetails.bid_Leader_id;
            var leader_name = props.bdLongShotRole.includes('Project Leader') ? 'Project Leader' : 'Bid Leader'
            var prevBidLeaderIndex = _.findIndex(opportunityDetails.ie_bid_team.internal_bid_team, { bid_team_role: leader_name });
            const [firstname, surname] = newBidTeam.label.split(' ');
            var selectedUserDetails = _.find(bidLeaderList, { firstname: firstname });

            opportunityDetails.bid_Leader = `${selectedUserDetails.firstname} ${selectedUserDetails.surname}`;

            var newBidLeaders = {};
            if (prevBidLeaderIndex === -1) {
                newBidLeaders = {
                    role: selectedUserDetails.role_name,
                    bid_team_role: leader_name,
                    team_member: opportunityDetails.bid_Leader,
                    user_id: selectedUserDetails._id,
                    hourly_rate: selectedUserDetails.hourlyrate,
                };
                setOpportunityDetails((prevOpportunityDetails) => ({
                    ...prevOpportunityDetails,
                    ['ie_bid_team']: {
                        ...prevOpportunityDetails['ie_bid_team'],
                        ['internal_bid_team']: [
                            ...prevOpportunityDetails['ie_bid_team']['internal_bid_team'],
                            newBidLeaders
                        ]
                    }
                }));

                setGlobalOpportunityData((prevOpportunityDetails) => ({
                    ...prevOpportunityDetails,
                    ['ie_bid_team']: {
                        ...prevOpportunityDetails['ie_bid_team'],
                        ['internal_bid_team']: [
                            ...prevOpportunityDetails['ie_bid_team']['internal_bid_team'],
                            newBidLeaders
                        ]
                    }
                }));
            } else {
                opportunityDetails.ie_bid_team.internal_bid_team[prevBidLeaderIndex].bid_team_role = "";
                var isExist = false;
                for (var b = 0; b < opportunityDetails.ie_bid_team.internal_bid_team.length; b++) {
                    if (opportunityDetails.ie_bid_team.internal_bid_team[b].team_member === newBidTeam.label) {
                        isExist = true;
                        opportunityDetails.ie_bid_team.internal_bid_team[b].bid_team_role = leader_name;
                        break;
                    }
                }

                if (!isExist) {
                    newBidLeaders = {
                        role: selectedUserDetails.role_name,
                        team_member: opportunityDetails.bid_Leader,
                        bid_team_role: leader_name,
                        user_id: selectedUserDetails._id,
                        hourly_rate: selectedUserDetails.hourlyrate,
                    };
                    setOpportunityDetails((prevOpportunityDetails) => ({
                        ...prevOpportunityDetails,
                        ['ie_bid_team']: {
                            ...prevOpportunityDetails['ie_bid_team'],
                            ['internal_bid_team']: [
                                ...prevOpportunityDetails['ie_bid_team']['internal_bid_team'],
                                newBidLeaders
                            ]
                        }
                    }));
                    setGlobalOpportunityData((prevOpportunityDetails) => ({
                        ...prevOpportunityDetails,
                        ['ie_bid_team']: {
                            ...prevOpportunityDetails['ie_bid_team'],
                            ['internal_bid_team']: [
                                ...prevOpportunityDetails['ie_bid_team']['internal_bid_team'],
                                newBidLeaders
                            ]
                        }
                    }));
                }
            }
            toastRef.current.showToast({
                type: 'success',
                message: "Project Leader Added"
            });
            setBidTeamUpdateAlertModal(false);
        } else {
            setBidTeamUpdateAlertModal(false);
            toastRef.current.showToast({
                type: 'error',
                message: "Please select the Project Leader"
            });
            setOpportunityDetails((prevOpportunityDetails) => ({
                ...prevOpportunityDetails,
                ['bid_Leader_id']: props.prevBidLeaderId
            }));
            setGlobalOpportunityData((prevOpportunityDetails) => ({
                ...prevOpportunityDetails,
                ['bid_Leader_id']: props.prevBidLeaderId
            }));
        }
    };
    const saveFooter = () => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement label="No" className="cancel-new-button" onClick={handleSaveModal} />
                    <ButtonElement type="submit" label="Yes" className="save-button" onClick={updateBidTeam} />
                </div>
            </div>
        );
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setIsStop(false)
    };

    const hideProjectNumAlertDialog = () => {
        setProjectNumAlertModal(false);
    };

    const projectNumAlertFooter = () => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement label="No" className="cancel-new-button" onClick={hideProjectNumAlertDialog} />
                    <ButtonElement type="submit" label="Yes" className="save-button" onClick={generateProjNum} />
                </div>
            </div>
        );
    };

    const bidTeamUpdateAlert = (e) => {
        const newLabel = e.target.value.label;
        const newId = e.target.value.id;
        const currentBidLeader = opportunityDetails.bid_Leader;
        const currentBidLeaderId = opportunityDetails.bid_Leader_id;
        if (newLabel === currentBidLeader && newId === currentBidLeaderId) {
            return;
        }

        setNewBidTeam(e.target.value);

        if (e.value.label !== '-- Please select --') {
            setNewBidTeam(e.target.value)
            setGlobalOpportunityData((prevData) => ({
                ...prevData,
                bid_Leader_id: e.target.value.id,
                bid_Leader: e.target.value.label
            }));
            setOpportunityDetails((prevData) => ({
                ...prevData,
                bid_Leader_id: e.target.value.id,
                bid_Leader: e.target.value.label
            }));
            setBidTeamUpdateAlertModal(true)
        }
    }

    const generateTenderReport = async () => {
        try {
            // Validating required parameters before making the API call
            if (!opportunityDetails?._id || !props?.customerId || !userId) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Unable to generate report due to missing details.'
                });
                return;
            }
            // Get current time
            const curTime = moment().format("hh:mm a");

            // Calling the API to generate the tender sales report
            const response = await generateTenderSalesReport(opportunityDetails._id, props.customerId, userId, curTime);

            // Checking if the response contains valid data before proceeding to download
            if (response?.data?.fileName) {
                downloadDocs(response.data.fileName);
            } else {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Failed to generate report. Please try again.'
                });
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred while generating the report. Please try again or contact Admin.'
            });
        }
    };



    const generateTenderDocumentReport = async () => {
        try {
            // Check if required details are available
            if (!opportunityDetails?._id || !props?.customerId || !userId) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Unable to generate report due to missing details.'
                });
                return;
            }

            let project_address = opportunityDetails.additional?.project_location || '';
            const post_code = opportunityDetails.additional?.project_post_code || '';

            project_address += post_code ? `, ${post_code}` : '';

            // Calling the API to generate the tender document report
            const response = await generateTenderDocumentReviewReport(
                opportunityDetails._id,
                props.customerId,
                userId,
                project_address
            );

            // Checking if the response contains valid data before proceeding to download
            if (response?.data?.fileName) {
                downloadDocs(response.data.fileName);
            } else {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Failed to generate report. Please try again.'
                });
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred while generating the report. Please try again or contact Admin.'
            });
        }
    };


    const calculateContract = (value) => {
        var contract_variation = 0

        if ((opportunityDetails.contract_variation && opportunityDetails.contract_variation.text) || getValues("contract_variation")) {
            contract_variation = getValues("contract_variation") ? getValues("contract_variation") : Number(
                opportunityDetails.contract_variation.text
                    ? opportunityDetails.contract_variation.text
                    : 0
            );
        }

        var contract_margin = 0;
        if ((opportunityDetails.summary.contract_margin && opportunityDetails.summary.contract_margin.text) || getValues("contract_margin")) {
            contract_margin = getValues("contract_margin") ? getValues("contract_margin") : Number(
                opportunityDetails.summary.contract_margin.text
                    ? opportunityDetails.summary.contract_margin.text
                    : 0
            );
        }

        contract_margin = typeof (contract_margin) == 'string' ? contract_margin?.includes('£') ? contract_margin.replace('£', '').trim() : contract_margin.trim() : contract_margin;

        var total_contract_value = parseFloat(value) + parseFloat(contract_variation);

        contract_margin = ((parseFloat(getValues("margin_expected_text")) / 100) * total_contract_value) + parseFloat(getValues("contract_variation_margin"))

        const updateDetails = (prevOpportunityDetails) => ({
            ...prevOpportunityDetails,
            ['contract_value']: {
                ...prevOpportunityDetails['contract_value'],
                ['text']: value
            },
            ['total_contract_value']: {
                ...prevOpportunityDetails['total_contract_value'],
                ['text']: total_contract_value
            },
            summary: {
                ...prevOpportunityDetails.summary,
                contract_margin: contract_margin
            }
        });
        setOpportunityDetails((prevOpportunityDetails) => updateDetails(prevOpportunityDetails));
        setGlobalOpportunityData((prevGlobalOpportunityData) => updateDetails(prevGlobalOpportunityData));

        setValue("total_contract_value", total_contract_value);
    }

    const calculateTotalContract = (value) => {
        var contract_value = 0

        if ((opportunityDetails.contract_value && opportunityDetails.contract_value.text) || getValues("contract_value")) {
            contract_value = getValues("contract_value") ? getValues("contract_value") : Number(
                opportunityDetails.contract_value.text
                    ? opportunityDetails.contract_value.text
                    : 0
            );
        }

        var contract_margin = 0;
        if ((opportunityDetails.summary.contract_margin && opportunityDetails.summary.contract_margin.text) || getValues("contract_margin")) {
            contract_margin = getValues("contract_margin") ? getValues("contract_margin") : Number(
                opportunityDetails.summary.contract_margin.text
                    ? opportunityDetails.summary.contract_margin.text
                    : 0
            );
        }

        contract_margin = typeof (contract_margin) == 'string' ? contract_margin?.includes('£') ? contract_margin.replace('£', '').trim() : contract_margin.trim() : contract_margin;

        var total_contract_value = parseFloat(contract_value) + parseFloat(value);

        contract_margin = ((parseFloat(getValues("margin_expected_text")) / 100) * total_contract_value) + parseFloat(getValues("contract_variation_margin"))

        const updateDetails = (prevOpportunityDetails) => ({
            ...prevOpportunityDetails,
            ['contract_variation']: value,
            ['total_contract_value']: {
                ...prevOpportunityDetails['total_contract_value'],
                ['text']: total_contract_value
            },
            summary: {
                ...prevOpportunityDetails.summary,
                contract_margin: contract_margin
            }
        });
        setOpportunityDetails((prevOpportunityDetails) => updateDetails(prevOpportunityDetails));
        setGlobalOpportunityData((prevGlobalOpportunityData) => updateDetails(prevGlobalOpportunityData));

        setValue("total_contract_value", total_contract_value)
    };

    const handleMarginExpected = (value) => {
        var contract_variation_margin = 0;
        if ((opportunityDetails.summary.contract_variation_margin) || getValues("contract_variation_margin")) {
            contract_variation_margin = getValues("contract_variation_margin") ? getValues("contract_variation_margin") : Number(
                opportunityDetails.summary.contract_variation_margin
                    ? opportunityDetails.summary.contract_variation_margin
                    : 0
            );
        }

        var total_contract_value = 0;
        if ((opportunityDetails.total_contract_value && opportunityDetails.total_contract_value.text) || getValues("total_contract_value")) {
            total_contract_value = getValues("total_contract_value") ? getValues("total_contract_value") : Number(
                opportunityDetails.total_contract_value.text
                    ? opportunityDetails.total_contract_value.text
                    : 0
            );
        }

        total_contract_value = typeof (total_contract_value) == 'string' ? total_contract_value?.includes('£') ? total_contract_value.replace('£', '').trim() : total_contract_value.trim() : total_contract_value;
        setOpportunityDetails((prevOpportunityDetails) => ({
            ...prevOpportunityDetails,
            ['summary']: {
                ...prevOpportunityDetails['summary'],
                ['margin_expected']: {
                    ...prevOpportunityDetails['summary']['margin_expected'],
                    text: value
                },
                ['contract_margin']: ((parseFloat(value) / 100) * parseFloat(total_contract_value)) + parseFloat(contract_variation_margin)
            },
        }));
        setGlobalOpportunityData((prevOpportunityDetails) => ({
            ...prevOpportunityDetails,
            ['summary']: {
                ...prevOpportunityDetails['summary'],
                ['margin_expected']: {
                    ...prevOpportunityDetails['summary']['margin_expected'],
                    text: value
                },
                ['contract_margin']: ((parseFloat(value) / 100) * parseFloat(total_contract_value)) + parseFloat(contract_variation_margin)
            },
        }));
        setValue('margin_expected_text', value)
        setValue("contract_margin", ((parseFloat(value) / 100) * parseFloat(total_contract_value)) + parseFloat(contract_variation_margin))
    }

    const handleBidStatusComments = (e) => {
        setGlobalOpportunityData((prevData) => ({
            ...prevData,
            bidStatus_comments: {
                ...prevData.bidStatus_comments,
                [globalOpportunityData.bid_status]: e.target.value
            },
        }));
        setOpportunityDetails((prevData) => ({
            ...prevData,
            bidStatus_comments: {
                ...prevData.bidStatus_comments,
                [opportunityDetails.bid_status]: e.target.value
            },
        }));
    }

    const handleContractMargin = (value) => {
        var margin_expected = 0;
        if ((opportunityDetails.summary.margin_expected && opportunityDetails.summary.margin_expected.text) || getValues("margin_expected_text")) {
            margin_expected = getValues("margin_expected_text") ? getValues("margin_expected_text") : Number(
                opportunityDetails.summary.margin_expected.text
                    ? opportunityDetails.summary.margin_expected.text
                    : 0
            );
        }

        var total_contract_value = 0;
        if ((opportunityDetails.total_contract_value && opportunityDetails.total_contract_value.text) || getValues("total_contract_value")) {
            total_contract_value = getValues("total_contract_value") ? getValues("total_contract_value") : Number(
                opportunityDetails.total_contract_value.text
                    ? opportunityDetails.total_contract_value.text
                    : 0
            );
        }

        total_contract_value = typeof (total_contract_value) == 'string' ? total_contract_value?.includes('£') ? total_contract_value.replace('£', '').trim() : total_contract_value.trim() : total_contract_value;
        setOpportunityDetails((prevOpportunityDetails) => ({
            ...prevOpportunityDetails,
            ['summary']: {
                ...prevOpportunityDetails['summary'],
                ['contract_variation_margin']: value,
                ['contract_margin']: ((parseFloat(margin_expected) / 100) * parseFloat(total_contract_value)) + parseFloat(value)
            },
        }));

        setGlobalOpportunityData((prevOpportunityDetails) => ({
            ...prevOpportunityDetails,
            ['summary']: {
                ...prevOpportunityDetails['summary'],
                ['contract_variation_margin']: value,
                ['contract_margin']: ((parseFloat(margin_expected) / 100) * parseFloat(total_contract_value)) + parseFloat(value)
            },
        }));
        setValue("contract_margin", ((parseFloat(margin_expected) / 100) * parseFloat(total_contract_value)) + parseFloat(value))
    }

    const handleGetClient = async () => {
        const cliResponse = await api.get("/api/v1/getClients", {
            params: { cust_id: props?.customerId, searchVal: selectedAssociatedClient, branch_id: opportunityDetails.branch_id },
        });
        setCliRes(cliResponse.data?.client)
        const associatedDisplayNames = cliResponse.data?.client?.map(
            (cli) => cli.client_name
        );
        setAssociatedDataClient(associatedDisplayNames);
    };

    const handleCode = (value) => {
        setOpportunityDetails((prevOpportunityDetails) => ({
            ...prevOpportunityDetails,
            ["additional"]: {
                ...prevOpportunityDetails["additional"],
                ["project_post_code"]: value,
            },
        }));
    };

    const handleInputChangeRadio = (value) => {
        setRadio(value);
    };

    const handleButtonClick = () => {
        setShowVideo(true);
    };

    const closeVideo = () => {
        setShowVideo(false);
    };

    return (
        <div>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="col-md-12 text-right">
                <ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
            </div>
            {
                (opportunityDetails && editData) && <form>
                    {
                        Object.entries(newModule)?.map(([key, value]) => (
                            <div key={key} className='mt-10'>
                                <Accordion activeIndex={0}>
                                    {
                                        <AccordionTab header={value} disabled>
                                            {
                                                key == 'obj1' &&
                                                <div className='new-field'>
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        {
                                                            isStop && opportunityDetails?.bid_status === 'Stop' &&
                                                            <div className="col-md-12 pl-0 button-container">
                                                                <label className="form-label text-left alert-danger">Further Status changes will not be allowed by system</label>
                                                            </div>
                                                        }
                                                        <div className="col-md-12 pl-0 button-container d-flex justify-end">
                                                            <ButtonElement type="button"
                                                                className={`${opportunityDetails?.bid_status === 'Active' ? 'active-button' : 'default-button'} button-portfolio`}
                                                                disabled={(isStop && opportunityDetails?.bid_status === 'Stop') || !statusPrivilege}
                                                                onClick={() => handleClick('Active')}
                                                            >
                                                                {_.find(props?.summaryData?.projectSumFields, { field_name: "Active" })?.display_name}
                                                            </ButtonElement>
                                                            <ButtonElement type="button"
                                                                className={`${opportunityDetails?.bid_status === 'Inactive' ? 'in-active-button' : 'default-button'} button-portfolio`}
                                                                disabled={(isStop && opportunityDetails?.bid_status === 'Stop') || !statusPrivilege}
                                                                onClick={() => handleClick('Inactive')}
                                                            >
                                                                {_.find(props?.summaryData?.projectSumFields, { field_name: "Inactive" })?.display_name}
                                                            </ButtonElement>
                                                            <ButtonElement type="button"
                                                                className={`${opportunityDetails?.bid_status === 'Won' ? 'won-button' : 'default-button'} button-portfolio`}
                                                                disabled={(isStop && opportunityDetails?.bid_status === 'Stop') || !statusPrivilege}
                                                                onClick={() => handleClick('Won')}
                                                            >
                                                                {_.find(props?.summaryData?.projectSumFields, { field_name: "Won" })?.display_name}
                                                            </ButtonElement>
                                                            <ButtonElement type="button"
                                                                className={`${opportunityDetails?.bid_status === 'Lost' ? 'lost-button' : 'default-button'} button-portfolio`}
                                                                disabled={(isStop && opportunityDetails?.bid_status === 'Stop') || !statusPrivilege}
                                                                onClick={() => handleClick('Lost')}
                                                            >
                                                                {_.find(props?.summaryData?.projectSumFields, { field_name: "Lost" })?.display_name}
                                                            </ButtonElement>
                                                            <ButtonElement type="button"
                                                                className={`${opportunityDetails?.bid_status === 'Stop' ? 'stop-button' : 'default-button'} button-portfolio`}
                                                                onClick={!((isStop && opportunityDetails?.bid_status === 'Stop') || !statusPrivilege) ? () => handleClick('Stop') : undefined}
                                                            >
                                                                {_.find(props?.summaryData?.projectSumFields, { field_name: "Stop" })?.display_name}
                                                            </ButtonElement>
                                                        </div>
                                                        <div className="col-md-12 pl-0">
                                                            {
                                                                _.find(props?.summaryData?.projectSumFields, { field_name: "Bid Status Notes" })?.field_status &&
                                                                <div className="form-group row align-items-center mb-0 mt-0 ">
                                                                    <div className="col-md-2 pl-0">
                                                                        <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "Bid Status Notes" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {
                                                                            customerTooltipData?.bid_status?.general_comments.status == true &&
                                                                            <div>
                                                                                <Tooltip target=".custom-target-icon" />

                                                                                <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                    data-pr-tooltip={customerTooltipData?.bid_status?.bidStatus_comments.text}
                                                                                    data-pr-position="right">
                                                                                </i>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <Controller
                                                                            name="bidStatus_comments"
                                                                            control={control}
                                                                            defaultValue={opportunityDetails.bidStatus_comments ? opportunityDetails.bidStatus_comments[opportunityDetails.bid_status] : ''}
                                                                            style={{ innerHeight: 10 }}
                                                                            render={({ field }) => {
                                                                                return (
                                                                                    <TextareaElement
                                                                                        id="bidStatus_comments"
                                                                                        name="bidStatus_comments"
                                                                                        {...field}
                                                                                        value={field.value !== undefined && field.value !== null ? field.value : opportunityDetails.bidStatus_comments ? opportunityDetails.bidStatus_comments[opportunityDetails.bid_status] : ''}
                                                                                        className="w-full"
                                                                                        rows={3}
                                                                                        onChange={(e) => {
                                                                                            handleBidStatusComments(e)
                                                                                            field.onChange(e.target.value)
                                                                                        }}
                                                                                    />
                                                                                );
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props?.summaryData?.projectSumFields, { field_name: "General Notes" })?.field_status &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-2 pl-0">
                                                                        <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "General Notes" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {
                                                                            customerTooltipData?.bid_status?.general_comments.status == true &&
                                                                            <div>
                                                                                <Tooltip target=".custom-target-icon" />

                                                                                <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                    data-pr-tooltip={customerTooltipData?.bid_status?.general_comments.text}
                                                                                    data-pr-position="right">
                                                                                </i>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <Controller
                                                                            name="general_notes"
                                                                            control={control}
                                                                            defaultValue={opportunityDetails?.general_notes}
                                                                            style={{ innerHeight: 10 }}
                                                                            render={({ field }) => {
                                                                                return (
                                                                                    <TextareaElement
                                                                                        id="general_notes"
                                                                                        name="general_notes"
                                                                                        {...field}
                                                                                        value={field.value !== undefined && field.value !== null ? field.value : opportunityDetails?.general_notes}
                                                                                        className="w-full"
                                                                                        rows={3}
                                                                                        onChange={(e) => {
                                                                                            setOpportunityDetails((prevData) => ({
                                                                                                ...prevData,
                                                                                                general_notes: e.target.value
                                                                                            }));
                                                                                            field.onChange(e.target.value)
                                                                                        }}
                                                                                    />
                                                                                );
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                key == 'obj2' &&
                                                <div className="new-field d-flex">
                                                    <div className='col-md-6 pl-0'>
                                                        {
                                                            _.find(props?.summaryData?.projectSumFields, { field_name: "Project ID" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "Project ID" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.opportunity?.opportunity_seq.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />
                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.opportunity?.opportunity_seq.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <label className="form-label text-left">{opportunityDetails?.opportunity_seq}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props?.summaryData?.projectSumFields, { field_name: "Project Number" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "Project Number" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.opportunity?.project_number.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />
                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.opportunity?.project_number.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className='col-md-4 pr-0'>
                                                                    <InputTextElementElement
                                                                        id="project_number"
                                                                        name="project_number"
                                                                        value={opportunityDetails?.project_number}
                                                                        className="w-full"
                                                                        placeholder="Text"
                                                                        disabled
                                                                    />
                                                                </div>
                                                                <div className="col pl-0">
                                                                    <label className="form-label text-left mb-0">
                                                                        <ButtonElement
                                                                            type="button"
                                                                            label="Generate"
                                                                            className="add-button-summary"
                                                                            onClick={confirmProjectNumGeneration}
                                                                            disabled={disableGenerate || opportunityDetails?.project_number != undefined}
                                                                        />
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props?.summaryData?.projectFieldsNew, { field_name: "Project Name" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props?.summaryData?.projectFieldsNew, { field_name: "Project Name" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.opportunity?.opportunity_name.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />
                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.opportunity?.opportunity_name.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <Controller
                                                                        name="opportunity_name"
                                                                        control={control}
                                                                        defaultValue={opportunityDetails?.opportunity_name || ''}
                                                                        rules={{ required: "Please Enter Valid Project Name!" }}
                                                                        style={{ innerHeight: 10 }}
                                                                        render={({ field }) => {
                                                                            return (
                                                                                <InputTextElementElement
                                                                                    placeholder="Text"
                                                                                    name="opportunity_name"
                                                                                    className="w-full"
                                                                                    {...field}
                                                                                    value={field.value || ''}
                                                                                    onChange={(e) => {
                                                                                        setOpportunityDetails((prevData) => ({
                                                                                            ...prevData,
                                                                                            opportunity_name: e.target.value
                                                                                        }));
                                                                                        field.onChange(e.target.value)
                                                                                    }
                                                                                    }
                                                                                />
                                                                            );
                                                                        }}
                                                                    />
                                                                    {errors.opportunity_name && <div className="text-xs text-red-500 ml-2 mt-0">{errors.opportunity_name.message}</div>}
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props?.summaryData?.projectFieldsNew, { field_name: "Project Alias" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props?.summaryData?.projectFieldsNew, { field_name: "Project Alias" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.opportunity?.opportunity_alias.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />

                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.opportunity?.opportunity_alias.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <Controller
                                                                        name="opportunity_alias"
                                                                        control={control}
                                                                        defaultValue={opportunityDetails?.opportunity_alias}
                                                                        rules={{ required: "Please Enter Valid Alias Name!" }}
                                                                        style={{ innerHeight: 10 }}
                                                                        render={({ field }) => {
                                                                            return (
                                                                                <InputTextElementElement
                                                                                    placeholder="Text"
                                                                                    name="opportunity_alias"
                                                                                    className="w-full"
                                                                                    {...field}
                                                                                    value={field.value !== undefined && field.value !== null ? field.value : opportunityDetails?.opportunity_alias}
                                                                                    onChange={(e) => {
                                                                                        setOpportunityDetails((prevData) => ({
                                                                                            ...prevData,
                                                                                            opportunity_alias: e.target.value
                                                                                        }));
                                                                                        field.onChange(e.target.value)
                                                                                    }
                                                                                    }
                                                                                />
                                                                            );
                                                                        }}
                                                                    />
                                                                    {errors.opportunity_alias && <div className="text-xs text-red-500 ml-2 mt-0">{errors.opportunity_alias.message}</div>}
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props?.summaryData?.projectSumFields, { field_name: "Project Description" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "Project Description" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.opportunity?.opportunity_description.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />
                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.opportunity?.opportunity_description.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <Controller
                                                                        name="opportunity_description"
                                                                        control={control}
                                                                        defaultValue={globalOpportunityData?.summary?.opportunity_description}
                                                                        rules={{ required: "Please Enter Valid Project Description!" }}
                                                                        style={{ innerHeight: 10 }}
                                                                        render={({ field }) => {
                                                                            return (
                                                                                <TextareaElement
                                                                                    placeholder="Text"
                                                                                    name="opportunity_description"
                                                                                    id="opportunity_description"
                                                                                    className="w-full"
                                                                                    // {...field}
                                                                                    defaultValue={
                                                                                        globalOpportunityData?.summary
                                                                                          ?.opportunity_description
                                                                                    }
                                                                                    value={globalOpportunityData?.summary?.opportunity_description}
                                                                                    rows={3}
                                                                                    onChange={(e) => {
                                                                                        setOpportunityDetails((prevData) => ({
                                                                                            ...prevData,
                                                                                            summary: {
                                                                                                ...prevData.summary,
                                                                                                opportunity_description: e.target.value
                                                                                            }
                                                                                        }));
                                                                                        field.onChange(e.target.value)
                                                                                        setGlobalOpportunityData((prevData) => ({
                                                                                            ...prevData,
                                                                                            summary: {
                                                                                              ...prevData.summary,
                                                                                              opportunity_description: e.target.value,
                                                                                            },
                                                                                        }))

                                                                                    }
                                                                                    }
                                                                                />
                                                                            );
                                                                        }}
                                                                    />
                                                                    {errors.opportunity_description && <div className="text-xs text-red-500 ml-2 mt-0">{errors.opportunity_description.message}</div>}
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props?.summaryData?.projectSumFields, { field_name: "Contract Description" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "Contract Description" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.opportunity?.contract_description.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />
                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.opportunity?.contract_description.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <Controller
                                                                        name="contract_description"
                                                                        control={control}
                                                                        defaultValue={opportunityDetails?.summary?.contract_description}
                                                                        rules={{ required: "Please Enter Valid Project Description!" }}
                                                                        style={{ innerHeight: 10 }}
                                                                        render={({ field }) => {
                                                                            return (
                                                                                <TextareaElement
                                                                                    placeholder="Text"
                                                                                    name="contract_description"
                                                                                    id="contract_description"
                                                                                    className="w-full"
                                                                                    // {...field}
                                                                                    defaultValue={
                                                                                        globalOpportunityData?.summary
                                                                                          ?.contract_description
                                                                                    }
                                                                                    value={field.value !== undefined && field.value !== null ? field.value : opportunityDetails?.summary?.contract_description}
                                                                                    rows={3}
                                                                                    onChange={(e) => {
                                                                                        setOpportunityDetails((prevData) => ({
                                                                                            ...prevData,
                                                                                            summary: {
                                                                                                ...prevData.summary,
                                                                                                contract_description: e.target.value
                                                                                            }
                                                                                        }));
                                                                                        field.onChange(e.target.value)
                                                                                    }
                                                                                    }
                                                                                />
                                                                            );
                                                                        }}
                                                                        // render={({ field }) => {
                                                                        //     return (
                                                                        //         <InputTextElementElement
                                                                        //             placeholder="Text"
                                                                        //             name="contract_description"
                                                                        //             className="w-full"
                                                                        //             {...field}
                                                                        //             value={field.value !== undefined && field.value !== null ? field.value : opportunityDetails?.summary?.contract_description}
                                                                        //             onChange={(e) => {
                                                                        //                 setOpportunityDetails((prevData) => ({
                                                                        //                     ...prevData,
                                                                        //                     summary: {
                                                                        //                         ...prevData.summary,
                                                                        //                         contract_description: e.target.value
                                                                        //                     }
                                                                        //                 }));
                                                                        //                 field.onChange(e.target.value)
                                                                        //             }
                                                                        //             }
                                                                        //         />
                                                                        //     );
                                                                        // }}
                                                                    />
                                                                    {errors.contract_description && <div className="text-xs text-red-500 ml-2 mt-0">{errors.contract_description.message}</div>}
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            props?.summaryData?.projectSelectFields?.find(
                                                                (project) =>
                                                                    project.field_name === "Project Address"
                                                            )?.field_status && (
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">
                                                                            {props?.summaryData?.projectSelectFields?.find(
                                                                                (project) =>
                                                                                    project.field_name === "Project Address"
                                                                            ).display_name || null}
                                                                            :
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {customerTooltipData?.additional
                                                                            ?.project_location?.status == true && (
                                                                                <div>
                                                                                    <Tooltip target=".custom-target-icon" />
                                                                                    <i
                                                                                        className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                        data-pr-tooltip={
                                                                                            customerTooltipData?.additional
                                                                                                ?.project_location?.text
                                                                                        }
                                                                                        data-pr-position="right"
                                                                                    ></i>
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                    <div className="col pr-0">
                                                                        <input
                                                                            type="text"
                                                                            value={projectAddressText || ""}
                                                                            onChange={(e) => {
                                                                                setProjectAddressText(e.target.value);
                                                                                // initializeAutocomplete()
                                                                            }}
                                                                            autoComplete="off"
                                                                            placeholder="Enter Project Address"
                                                                            className="w-full project-address" // Add class for easy selection
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                        {
                                                            props?.summaryData?.projectSelectFields?.find(
                                                                (project) =>
                                                                    project.field_name === "Project Coordinates"
                                                            )?.field_status && (
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">
                                                                            {props?.summaryData?.projectSelectFields?.find(
                                                                                (project) =>
                                                                                    project.field_name ===
                                                                                    "Project Coordinates"
                                                                            ).display_name || null}
                                                                            :
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {customerTooltipData?.additional
                                                                            ?.project_coordinates?.status == true && (
                                                                                <div>
                                                                                    <Tooltip target=".custom-target-icon" />
                                                                                    <i
                                                                                        className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                        data-pr-tooltip={
                                                                                            customerTooltipData?.additional
                                                                                                ?.project_coordinates?.text
                                                                                        }
                                                                                        data-pr-position="right"
                                                                                    ></i>
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                    <div className="col pr-0">
                                                                        <InputTextElementElement
                                                                            type="text"
                                                                            value={projectCoordinates || ""}
                                                                            //   onChange={(e) =>
                                                                            //     setProjectAddressText(e.target.value)
                                                                            //   }
                                                                            placeholder=""
                                                                            className="w-full"
                                                                            readOnly
                                                                            disabled={true}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                        {
                                                            props?.summaryData?.projectSelectFields?.find(
                                                                (project) =>
                                                                    project.field_name === "Project Post Code"
                                                            )?.field_status && (
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">
                                                                            {props?.summaryData?.projectSelectFields?.find(
                                                                                (project) =>
                                                                                    project.field_name === "Project Post Code"
                                                                            ).display_name || null}
                                                                            :
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {customerTooltipData?.additional
                                                                            ?.project_post_code?.status == true && (
                                                                                <div>
                                                                                    <Tooltip target=".custom-target-icon" />
                                                                                    <i
                                                                                        className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                        data-pr-tooltip={
                                                                                            customerTooltipData?.additional
                                                                                                ?.project_post_code?.text
                                                                                        }
                                                                                        data-pr-position="right"
                                                                                    ></i>
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                    <div className="col pr-0">
                                                                        <InputTextElementElement
                                                                            type="text"
                                                                            value={
                                                                                opportunityDetails.additional
                                                                                    ?.project_post_code || props.opportunityData.additional?.project_post_code
                                                                            }
                                                                            onChange={(e) =>
                                                                                //   setProjectAddressText(e.target.value)
                                                                                handleCode(e.target.value)
                                                                            }
                                                                            placeholder=""
                                                                            className="w-full"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                    <div className='col-md-6 pl-0'>
                                                        {
                                                            props?.summaryData?.projectSelectFields?.find(
                                                                (project) =>
                                                                    project.field_name === "Framework Opportunity"
                                                            )?.field_status && (
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">
                                                                            {props?.summaryData?.projectSelectFields?.find(
                                                                                (project) =>
                                                                                    project.field_name ===
                                                                                    "Framework Opportunity"
                                                                            ).display_name || null}
                                                                            :
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {customerTooltipData?.opportunity
                                                                            ?.existing_framework?.status == true && (
                                                                                <div>
                                                                                    <Tooltip target=".custom-target-icon" />
                                                                                    <i
                                                                                        className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                        data-pr-tooltip={
                                                                                            customerTooltipData?.opportunity
                                                                                                ?.existing_framework?.text
                                                                                        }
                                                                                        data-pr-position="right"
                                                                                    ></i>
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                    <div className="col pr-0">
                                                                        <RadioElement
                                                                            options={[
                                                                                { key: "Yes", name: "Yes" },
                                                                                { key: "No", name: "No" },
                                                                            ]}
                                                                            onChangeRadio={(value) => {
                                                                                setOpportunityDetails((prevData) => ({
                                                                                    ...prevData,
                                                                                    opportunity: {
                                                                                        ...prevData.opportunity,
                                                                                        existing_framework: value,
                                                                                    }
                                                                                }));
                                                                                handleInputChangeRadio(value);
                                                                            }}
                                                                            value={radio || props.opportunityData?.opportunity?.existing_framework}
                                                                            className="radio-group-class" // Add any additional classes if necessary
                                                                            disabled={false} // Adjust the disabled prop as needed
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                        {
                                                            props?.summaryData?.frameworkFieldsNew?.find(
                                                                (project) => project.field_name === "Framework"
                                                            )?.field_status &&
                                                            (radio === "Yes" || props.opportunityData?.opportunity?.existing_framework === "Yes") && (
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">
                                                                            {props?.summaryData?.frameworkFieldsNew.find(
                                                                                (project) =>
                                                                                    project.field_name === "Framework"
                                                                            ).display_name || null}
                                                                            :
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {customerTooltipData?.opportunity?.framework
                                                                            ?.status == true && (
                                                                                <div>
                                                                                    <Tooltip target=".custom-target-icon" />
                                                                                    <i
                                                                                        className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                        data-pr-tooltip={
                                                                                            customerTooltipData?.opportunity
                                                                                                ?.framework?.text
                                                                                        }
                                                                                        data-pr-position="right"
                                                                                    ></i>
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                    <div className="col pr-0">
                                                                        <AutoCompleteElement
                                                                            value={
                                                                                selectedFramework
                                                                            }
                                                                            onChangeValue={(e) => {
                                                                                setOpportunityDetails((prevData) => ({
                                                                                    ...prevData,
                                                                                    opportunity: {
                                                                                        ...prevData.opportunity,
                                                                                        framework_name: e.value,
                                                                                    }
                                                                                }));
                                                                                setSelectedFramework(e.value)
                                                                            }}
                                                                            placeholder="Enter Framework Name"
                                                                            suggestions={frameworkData}
                                                                            completeMethod={handleGetFramework}
                                                                            className="w-full"
                                                                            isPurposeScore={true}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                        {
                                                            _.find(props?.summaryData?.commanFieldsNew, { field_name: "Services" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props?.summaryData?.commanFieldsNew, { field_name: "Services" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.opportunity?.services?.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />
                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.opportunity?.services?.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className='col-md-7 pr-0 pad-t-8 pad-b-8'>
                                                                    <Controller
                                                                        name="services"
                                                                        control={control}
                                                                        defaultValue={editData.services}
                                                                        style={{ innerHeight: 10 }}
                                                                        render={({ field }) => {
                                                                            return (
                                                                                <DropdownElement
                                                                                    // onChangeValue={(e) => field.onChange(e.value)}
                                                                                    id="services"
                                                                                    options={(client?.Services != undefined && client?.Services.length > 0) ? client?.Services : []}
                                                                                    optionLabel="label"
                                                                                    placeholder="-- Please select --"
                                                                                    className="w-full"
                                                                                    {...field}
                                                                                    maxSelectedLabels={1}
                                                                                    value={field.value || editData.services}
                                                                                    onChange={(e) => {
                                                                                        setOpportunityDetails((prevData) => ({
                                                                                            ...prevData,
                                                                                            services: e.value.label
                                                                                        }));
                                                                                        field.onChange(e.value)
                                                                                    }
                                                                                    }
                                                                                />
                                                                            );
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            props?.summaryData?.commanFieldsNew?.find(
                                                                (project) => project.field_name === "Sector"
                                                            )?.field_status && (
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">
                                                                            {props?.summaryData?.commanFieldsNew.find(
                                                                                (project) => project.field_name === "Sector"
                                                                            ).display_name || null}
                                                                            :
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {
                                                                            customerTooltipData?.opportunity?.sector?.status == true &&
                                                                            <div>
                                                                                <Tooltip target=".custom-target-icon" />
                                                                                <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                    data-pr-tooltip={customerTooltipData?.opportunity?.sector?.text}
                                                                                    data-pr-position="right">
                                                                                </i>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                                                                        <Controller
                                                                            name="sector"
                                                                            control={control}
                                                                            defaultValue={editData.sectorDetails}
                                                                            style={{ innerHeight: 10 }}
                                                                            render={({ field }) => {
                                                                                return (
                                                                                    <DropdownElement
                                                                                        id="sector"
                                                                                        {...field}
                                                                                        options={(props.sector != undefined && props.sector.length > 0) ? props.sector : []}
                                                                                        value={field.value || editData.sectorDetails}
                                                                                        optionLabel="label"
                                                                                        placeholder="-- Please select --"
                                                                                        className="w-full"
                                                                                        onChange={(e) => {
                                                                                            setOpportunityDetails((prevData) => ({
                                                                                                ...prevData,
                                                                                                sector: e.value.label
                                                                                            }));
                                                                                            field.onChange(e.value);
                                                                                        }}
                                                                                    />
                                                                                );
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                        {
                                                            props?.summaryData?.commanFieldsNew?.find(
                                                                (project) => project.field_name === "Region"
                                                            )?.field_status && (
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">
                                                                            {props?.summaryData?.commanFieldsNew.find(
                                                                                (project) => project.field_name === "Region"
                                                                            ).display_name || null}
                                                                            :
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {customerTooltipData?.additional?.region
                                                                            ?.status == true && (
                                                                                <div>
                                                                                    <Tooltip target=".custom-target-icon" />
                                                                                    <i
                                                                                        className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                        data-pr-tooltip={
                                                                                            customerTooltipData?.additional?.region
                                                                                                ?.text
                                                                                        }
                                                                                        data-pr-position="right"
                                                                                    ></i>
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                    <div className="col pr-0">
                                                                        <AutoCompleteElement
                                                                            value={regionsText}
                                                                            onChangeValue={(e) => {
                                                                                setOpportunityDetails((prevData) => ({
                                                                                    ...prevData,
                                                                                    additional: {
                                                                                        ...prevData.additional,
                                                                                        region: e.value,
                                                                                    }
                                                                                }))
                                                                                setRegionsText(e.value)
                                                                            }} // Set the value when user types
                                                                            placeholder="Region"
                                                                            suggestions={regions.map(
                                                                                (region) => region.label
                                                                            )} // Use .label to ensure it's a string
                                                                            completeMethod={getRegions} // Call getRegions to filter the suggestions
                                                                            className="w-full"
                                                                            autocomplete="off"
                                                                            isPurposeScore={true}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                        {/* {
                                                            _.find(props?.summaryData?.projectSumFields, { field_name: "Work Type" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "Work Type" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.opportunity?.work_type.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />

                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.opportunity?.work_type.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className='col-md-7 pr-0 pad-t-8 pad-b-8'>
                                                                    <Controller
                                                                        name="WorkType"
                                                                        control={control}
                                                                        defaultValue={client?.WorkType?.filter(
                                                                            (item) => item.label === globalOpportunityData?.summary?.work_type
                                                                        )[0]}
                                                                        style={{ innerHeight: 10 }}
                                                                        render={({ field }) => {
                                                                            return (
                                                                                <DropdownElement
                                                                                    id="WorkType"
                                                                                    name="WorkType"
                                                                                    options={client?.WorkType}
                                                                                    optionLabel="label"
                                                                                    placeholder="-- Please select --"
                                                                                    className="w-full"
                                                                                    {...field}
                                                                                    maxSelectedLabels={1}
                                                                                    value={field.value || client?.WorkType?.filter(
                                                                                        (item) => item.label === globalOpportunityData?.summary?.work_type
                                                                                    )[0]}
                                                                                    // ref={(el) => {
                                                                                    //     props.setElement((prevData) => ({
                                                                                    //         ...prevData,
                                                                                    //         ["WorkType"]: el,
                                                                                    //     }));
                                                                                    // }}
                                                                                    onChange={(e) => {
                                                                                        setGlobalOpportunityData((prevData) => ({
                                                                                            ...prevData,
                                                                                            summary: {
                                                                                                ...prevData.summary,
                                                                                                work_type: e.value.label
                                                                                            }
                                                                                        }));
                                                                                        props.computeScore(0, "WorkType", e.value, client?.WorkType?.filter(
                                                                                            (item) => item.label === globalOpportunityData?.summary?.work_type
                                                                                        )[0]);
                                                                                        field.onChange(e.value)
                                                                                    }
                                                                                    }
                                                                                />
                                                                            );
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props?.summaryData?.projectSumFields, { field_name: "Form of Contract" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "Form of Contract" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.opportunity?.form_of_contract.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />

                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.opportunity?.form_of_contract.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>

                                                                <div className='col-md-7 pr-0 pad-t-8 pad-b-8'>
                                                                    <Controller
                                                                        name="form_of_contract"
                                                                        control={control}
                                                                        defaultValue={client?.formOfContract1?.filter(
                                                                            (item) => item.label === globalOpportunityData?.summary?.form_of_contract
                                                                        )[0]}
                                                                        style={{ innerHeight: 10 }}
                                                                        render={({ field }) => {
                                                                            return (
                                                                                <DropdownElement
                                                                                    // onChange={(e) => field.onChange(e.value)}
                                                                                    id="FormOfContractV1"
                                                                                    name="FormOfContractV1"
                                                                                    options={client?.formOfContract1}
                                                                                    optionLabel="label"
                                                                                    placeholder="-- Please select --"
                                                                                    className="w-full"
                                                                                    {...field}
                                                                                    maxSelectedLabels={1}
                                                                                    value={field.value || client?.formOfContract1?.filter(
                                                                                        (item) => item.label === globalOpportunityData?.summary?.form_of_contract
                                                                                    )[0]}
                                                                                    // ref={(el) => {
                                                                                    //     props.setElement((prevData) => ({
                                                                                    //         ...prevData,
                                                                                    //         ["FormOfContractV1"]: el,
                                                                                    //     }));
                                                                                    // }}
                                                                                    onChange={(e) => {
                                                                                        setGlobalOpportunityData((prevData) => ({
                                                                                            ...prevData,
                                                                                            summary: {
                                                                                                ...prevData.summary,
                                                                                                form_of_contract: e.value.label
                                                                                            }
                                                                                        }));
                                                                                        props.computeScore(0, "FormOfContractV1", e.value, client?.formOfContract1?.filter(
                                                                                            (item) => item.label === globalOpportunityData?.summary?.form_of_contract
                                                                                        )[0]);
                                                                                        field.onChange(e.value)
                                                                                    }
                                                                                    }
                                                                                />
                                                                            );
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props?.summaryData?.projectSumFields, { field_name: "Procurement Route" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "Procurement Route" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.opportunity?.procurement_route.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />

                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.opportunity?.procurement_route.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className='col-md-7 pr-0 pad-t-8 pad-b-8'>
                                                                    <Controller
                                                                        name="procurement_route"
                                                                        control={control}
                                                                        defaultValue={client?.ProcurementRoute?.filter(
                                                                            (item) => item.label === globalOpportunityData?.summary?.procurement_route
                                                                        )[0]}
                                                                        style={{ innerHeight: 10 }}
                                                                        render={({ field }) => {
                                                                            return (
                                                                                <DropdownElement
                                                                                    id="ProcurementRoute"
                                                                                    name="ProcurementRoute"
                                                                                    options={client?.ProcurementRoute}
                                                                                    optionLabel="label"
                                                                                    placeholder="-- Please select --"
                                                                                    className="w-full"
                                                                                    {...field}
                                                                                    maxSelectedLabels={1}
                                                                                    value={field.value || client?.ProcurementRoute?.filter(
                                                                                        (item) => item.label === globalOpportunityData?.summary?.procurement_route
                                                                                    )[0]}
                                                                                    // ref={(el) => {
                                                                                    //     props.setElement((prevData) => ({
                                                                                    //         ...prevData,
                                                                                    //         ["ProcurementRoute"]: el,
                                                                                    //     }));
                                                                                    // }}
                                                                                    onChange={(e) => {
                                                                                        setGlobalOpportunityData((prevData) => ({
                                                                                            ...prevData,
                                                                                            summary: {
                                                                                                ...prevData.summary,
                                                                                                procurement_route: e.value.label
                                                                                            }
                                                                                        }));
                                                                                        props.computeScore(0, "ProcurementRoute", e.value, client?.ProcurementRoute?.filter(
                                                                                            (item) => item.label === globalOpportunityData?.summary?.procurement_route
                                                                                        )[0]);
                                                                                        field.onChange(e.value)
                                                                                    }
                                                                                    }
                                                                                />
                                                                            );
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        } */}
                                                        {
                                                            _.find(props?.summaryData?.clientFieldsNew, { field_name: "Client Name" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props?.summaryData?.clientFieldsNew, { field_name: "Client Name" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.opportunity?.client.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />

                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.opportunity?.client.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className='col-md-7 pr-0 pad-t-8 pad-b-8'>
                                                                    <AutoCompleteElement
                                                                        id="client"
                                                                        value={selectedAssociatedClient || editData?.client_name?.label}
                                                                        onChangeValue={(e) => {
                                                                            setValue('client', e.value)
                                                                            setSelectedAssociatedClient(e.value)
                                                                            setOpportunityDetails((prevData) => ({
                                                                                ...prevData,
                                                                                client_name: e.value
                                                                            }));
                                                                        }}
                                                                        placeholder="Search Client Name"
                                                                        suggestions={associatedDataClient}
                                                                        autocomplete="off"
                                                                        completeMethod={handleGetClient}
                                                                        className="w-full"
                                                                        isPurposeScore={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            props?.summaryData?.clientFieldsNew?.find(
                                                                (project) =>
                                                                    project.field_name === "Client Classification"
                                                            )?.field_status && (
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">
                                                                            {props?.summaryData?.clientFieldsNew.find(
                                                                                (project) =>
                                                                                    project.field_name ===
                                                                                    "Client Classification"
                                                                            ).display_name || null}
                                                                            :
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {" "}
                                                                        {customerTooltipData?.additional
                                                                            ?.client_classification?.status == true && (
                                                                                <div>
                                                                                    <Tooltip target=".custom-target-icon" />
                                                                                    <i
                                                                                        className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                        data-pr-tooltip={
                                                                                            customerTooltipData?.additional
                                                                                                ?.client_classification?.text
                                                                                        }
                                                                                        data-pr-position="right"
                                                                                    ></i>
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                    <div className="col pr-0">
                                                                        <Controller
                                                                            name="ClientClassificationV1"
                                                                            control={control}
                                                                            defaultValue={
                                                                                globalOpportunityData?.additional?.client_classification
                                                                            }
                                                                            style={{ innerHeight: 10 }}
                                                                            render={({ field }) => (
                                                                                <MultiSelectElement
                                                                                    id="ClientClassificationV1"
                                                                                    name="ClientClassificationV1"
                                                                                    options={props.clientClassificationV1.map(({ _id, score, ...rest }) => rest)}
                                                                                    optionLabel="label"
                                                                                    placeholder="-- Please select --"
                                                                                    className="w-full"
                                                                                    {...field}
                                                                                    maxSelectedLabels={1}
                                                                                    // ref={(el) => {
                                                                                    //   props.setElement((prevData) => ({
                                                                                    //     ...prevData,
                                                                                    //     ["ClientClassificationV1"]: el,
                                                                                    //   }));
                                                                                    // }}
                                                                                    onChangeValue={(e) => {
                                                                                        // props.computeScore(
                                                                                        //   0,
                                                                                        //   "ClientClassificationV1"
                                                                                        // );
                                                                                        setOpportunityDetails((prevData) => ({
                                                                                            ...prevData,
                                                                                            additional: {
                                                                                                ...prevData.additional,
                                                                                                client_classification: e.value,
                                                                                            }
                                                                                        }));
                                                                                        field.onChange(e.value);
                                                                                    }}
                                                                                    value={globalOpportunityData?.additional?.client_classification.map(({ _id, ...rest }) => rest)}
                                                                                />
                                                                            )}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                        {
                                                            props?.summaryData?.clientFieldsNew?.find(
                                                                (project) => project.field_name === "Client Type"
                                                            )?.field_status && (
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">
                                                                            {props?.summaryData?.clientFieldsNew.find(
                                                                                (project) =>
                                                                                    project.field_name === "Client Type"
                                                                            ).display_name || null}
                                                                            :
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {" "}
                                                                        {customerTooltipData?.additional?.client_type
                                                                            ?.status == true && (
                                                                                <div>
                                                                                    <Tooltip target=".custom-target-icon" />
                                                                                    <i
                                                                                        className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                        data-pr-tooltip={
                                                                                            customerTooltipData?.additional
                                                                                                ?.client_type?.text
                                                                                        }
                                                                                        data-pr-position="right"
                                                                                    ></i>
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                    <div className="col pr-0">
                                                                        <Controller
                                                                            name="ClientTypeV1"
                                                                            control={control}
                                                                            defaultValue={
                                                                                globalOpportunityData?.additional?.client_type
                                                                            }
                                                                            style={{ innerHeight: 10 }}
                                                                            render={({ field }) => (
                                                                                <MultiSelectElement
                                                                                    id="ClientTypeV1"
                                                                                    name="ClientTypeV1"
                                                                                    options={props.clientType}
                                                                                    optionLabel="label"
                                                                                    placeholder="-- Please select --"
                                                                                    className="w-full"
                                                                                    {...field}
                                                                                    maxSelectedLabels={1}
                                                                                    // ref={(el) => {
                                                                                    //   props.setElement((prevData) => ({
                                                                                    //     ...prevData,
                                                                                    //     ["ClientTypeV1"]: el,
                                                                                    //   }));
                                                                                    // }}
                                                                                    onChangeValue={(e) => {
                                                                                        // props.computeScore(0, "ClientTypeV1");
                                                                                        setOpportunityDetails((prevData) => ({
                                                                                            ...prevData,
                                                                                            additional: {
                                                                                                ...prevData.additional,
                                                                                                client_type: e.value,
                                                                                            }
                                                                                        }));
                                                                                        field.onChange(e.value);
                                                                                    }}
                                                                                    value={opportunityDetails?.additional?.client_type.map(({ _id, ...rest }) => rest)}
                                                                                />
                                                                            )}
                                                                        />
                                                                    </div>
                                                                    {
                                                                        props.enableClientTypeDesc && (
                                                                            <div className="col pr-0">
                                                                                <TextareaElement
                                                                                    id="client_type_description"
                                                                                    name="client_type_description"
                                                                                    defaultValue={
                                                                                        props.opportunityData?.additional
                                                                                            .client_type_description
                                                                                    }
                                                                                    //   onChange={(e) => {
                                                                                    //     setValue("summary.client_desc", e.target.value);
                                                                                    //   }}
                                                                                    //   register={register("summary.client_desc")}
                                                                                    className="w-full"
                                                                                    rows={3}
                                                                                />
                                                                            </div>
                                                                        )
                                                                    }
                                                                </div>
                                                            )
                                                        }
                                                        {
                                                            _.find(clientFieldsNew, { field_name: "Sector" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(clientFieldsNew, { field_name: "Sector" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.opportunity?.sector.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />

                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.opportunity?.sector.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className='col-md-7 pr-0 pad-t-8 pad-b-8'>
                                                                    <Controller
                                                                        name="sector"
                                                                        control={control}
                                                                        defaultValue={editData.sector}
                                                                        style={{ innerHeight: 10 }}
                                                                        render={({ field }) => {
                                                                            return (
                                                                                <DropdownElement
                                                                                    // onChangeValue={(e) => field.onChange(e.value)}
                                                                                    id="sector"
                                                                                    options={(client?.SectorV1 != undefined && client?.SectorV1.length > 0) ? client?.SectorV1 : []}
                                                                                    optionLabel="label"
                                                                                    placeholder="-- Please select --"
                                                                                    className="w-full"
                                                                                    {...field}
                                                                                    maxSelectedLabels={1}
                                                                                    onChange={(e) => {
                                                                                        setOpportunityDetails((prevData) => ({
                                                                                            ...prevData,
                                                                                            sector: e.value.label
                                                                                        }));
                                                                                        field.onChange(e.value)
                                                                                    }
                                                                                    }
                                                                                />
                                                                            );
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props?.summaryData?.projectSumFields, { field_name: "Project Alert Flag" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "Project Alert Flag" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.opportunity?.project_alert_flag.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />

                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.opportunity?.project_alert_flag.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <RadioElement
                                                                        id="project_alert_flag"
                                                                        options={[{ key: 'yes', name: "Yes" }, { key: 'no', name: "No" }]}
                                                                        value={opportunityDetails?.project_alert_flag?.radio}
                                                                        onChangeRadio={(value) => {
                                                                            handleInputChange("project_alert_flag", value);
                                                                        }}
                                                                        className="radio-group-class"
                                                                    />
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            opportunityDetails?.project_alert_flag?.radio === "yes" &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">&nbsp;</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0"></div>
                                                                <div className='col pr-0'>
                                                                    <Controller
                                                                        name="project_alert_flag_text"
                                                                        control={control}
                                                                        defaultValue={opportunityDetails?.project_alert_flag.text}
                                                                        style={{ innerHeight: 10 }}
                                                                        render={({ field }) => {
                                                                            return (
                                                                                <TextareaElement
                                                                                    id="project_alert_flag_text"
                                                                                    name="project_alert_flag_text"
                                                                                    {...field}
                                                                                    value={field.value !== undefined && field.value !== null ? field.value : opportunityDetails?.project_alert_flag.text}
                                                                                    className="w-full"
                                                                                    rows={3}
                                                                                    onChange={(e) => {
                                                                                        setOpportunityDetails((prevData) => ({
                                                                                            ...prevData,
                                                                                            project_alert_flag: {
                                                                                                ...prevData.project_alert_flag,
                                                                                                text: e.target.value
                                                                                            }
                                                                                        }));
                                                                                        field.onChange(e.target.value)
                                                                                    }}
                                                                                />
                                                                            );
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                            {
                                                key == 'obj3' && sectionPermissions && sectionPermissions['Bid Team'] &&
                                                <div className='new-field d-flex'>
                                                    <div className="col-md-6 pl-0">
                                                        {
                                                            _.find(props?.summaryData?.projectFieldsNew, { field_name: "Bid Leader" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props?.summaryData?.projectFieldsNew, { field_name: "Bid Leader" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.team?.bid_Leader?.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />

                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.team?.bid_Leader?.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <SingleSelectElement
                                                                        onChangeValue={(e) => bidTeamUpdateAlert(e)}
                                                                        id="bid_Leader_id"
                                                                        options={(bidOptions != undefined && bidOptions.length > 0) ? bidOptions : []}
                                                                        optionLabel="label"
                                                                        placeholder="-- Please select --"
                                                                        className="w-full"
                                                                        maxSelectedLabels={1}
                                                                        value={editData?.bid_leader}
                                                                    />
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props?.summaryData?.commanFieldsNew, { field_name: "Business Unit" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props?.summaryData?.commanFieldsNew, { field_name: "Business Unit" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.team?.business_unit?.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />

                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.team?.business_unit?.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>

                                                                <div className='col-md-7 pr-0 pad-t-8 pad-b-8'>
                                                                    <Controller
                                                                        name="business_unit"
                                                                        control={control}
                                                                        defaultValue={editData?.business_unit}
                                                                        style={{ innerHeight: 10 }}
                                                                        render={({ field }) => {
                                                                            return (
                                                                                <DropdownElement
                                                                                    id="business_unit"
                                                                                    options={(client?.BusinessUnit != undefined && client?.BusinessUnit.length > 0) ? client?.BusinessUnit : []}
                                                                                    optionLabel="label"
                                                                                    placeholder="-- Please select --"
                                                                                    className="w-full"
                                                                                    {...field}
                                                                                    maxSelectedLabels={1}
                                                                                    value={field.value || editData?.business_unit}
                                                                                    onChange={(e) => {
                                                                                        setOpportunityDetails((prevData) => ({
                                                                                            ...prevData,
                                                                                            business_unit: e.value.label
                                                                                        }));
                                                                                        field.onChange(e.value)
                                                                                    }
                                                                                    }
                                                                                />
                                                                            );
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className='col-md-6 pl-0'>
                                                        {
                                                            _.find(customerTable?.modules, { display_name: "Portfolio" })
                                                                ?.sub_modules.find(sub_module => sub_module.sub_module_name === "Summary")
                                                                ?.tables[0]?.status &&
                                                            <div className="box-border">
                                                                <div className="form-group row align-items-center mb-0">
                                                                    <div className="col-md-6 pl-0">
                                                                        <p className="label-text">
                                                                            {_.find(customerTable?.modules, { display_name: "Portfolio" })
                                                                                ?.sub_modules.find(sub_module => sub_module.sub_module_name === "Summary")
                                                                                ?.tables[0]?.display_name}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div className='w-50'>
                                                                    {
                                                                        opportunityDetails?.ie_bid_team?.internal_bid_team?.map((teamMember, memberIndex) => (
                                                                            <li>
                                                                                <label className="form-label text-left" key={memberIndex}>{teamMember.team_member}</label>
                                                                            </li>
                                                                        ))
                                                                    }
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                            {
                                                key == 'obj4' &&
                                                <div className='new-field'>
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-6 pl-0">
                                                            {
                                                                _.find(props?.summaryData?.projectFieldsNew, { field_name: "Estimated Tender Due Date" })?.field_status &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props?.summaryData?.projectFieldsNew, { field_name: "Estimated Tender Due Date" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {
                                                                            customerTooltipData?.contract?.tender_due.status == true &&
                                                                            <div>
                                                                                <Tooltip target=".custom-target-icon" />

                                                                                <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                    data-pr-tooltip={customerTooltipData?.contract?.tender_due.text}
                                                                                    data-pr-position="right">
                                                                                </i>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    <div className='col pr-0 d-flex align-items-center'>
                                                                        <RadioElement
                                                                            id="tender_due"
                                                                            options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
                                                                            value={globalOpportunityData?.tender_due?.radio}
                                                                            onChangeRadio={(value) => {
                                                                                handleInputChange("tender_due", value);
                                                                            }}
                                                                            className="radio-group-class"
                                                                        />
                                                                        <CalendarElement
                                                                            id="tender_due"
                                                                            className='ml-10'
                                                                            defaultValue={parseDateString(globalOpportunityData?.tender_due?.text)}
                                                                            value={parseDateString(globalOpportunityData?.tender_due?.text)}
                                                                            onChange={(value) => {
                                                                                handleCalenderInputChange("tender_due", formatDate(value.value));
                                                                            }}
                                                                            maxLength="50"
                                                                            placeholder="Date"
                                                                            autocomplete="off"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props?.summaryData?.projectSumFields, { field_name: "Tender Due Out" })?.field_status &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "Tender Due Out" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {
                                                                            customerTooltipData?.contract?.tender_due_out.status == true &&
                                                                            <div>
                                                                                <Tooltip target=".custom-target-icon" />

                                                                                <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                    data-pr-tooltip={customerTooltipData?.contract?.tender_due_out.text}
                                                                                    data-pr-position="right">
                                                                                </i>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    <div className='col pr-0 d-flex align-items-center'>
                                                                        <RadioElement
                                                                            id="tender_due_out"
                                                                            options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
                                                                            value={opportunityDetails?.tender_due_out?.radio}
                                                                            onChangeRadio={(value) => {
                                                                                handleInputChange("tender_due_out", value);
                                                                            }}
                                                                            className="radio-group-class"
                                                                        />

                                                                        <CalendarElement
                                                                            id="tender_due_out"
                                                                            className='ml-10'
                                                                            defaultValue={parseDateString(opportunityDetails?.tender_due_out?.text)}
                                                                            value={parseDateString(opportunityDetails?.tender_due_out?.text)}
                                                                            onChange={(value) => {
                                                                                handleCalenderInputChange("tender_due_out", formatDate(value.value));
                                                                            }}
                                                                            maxLength="50"
                                                                            placeholder="Date"
                                                                            autocomplete="off"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props?.summaryData?.projectSumFields, { field_name: "Award Date" })?.field_status &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "Award Date" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {
                                                                            customerTooltipData?.contract?.award_date.status == true &&
                                                                            <div>
                                                                                <Tooltip target=".custom-target-icon" />

                                                                                <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                    data-pr-tooltip={customerTooltipData?.contract?.award_date.text}
                                                                                    data-pr-position="right">
                                                                                </i>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    <div className='col pr-0 d-flex align-items-center'>
                                                                        <RadioElement
                                                                            id="award_date"
                                                                            options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
                                                                            value={opportunityDetails?.summary?.award_date?.radio}
                                                                            onChangeRadio={(value) => {
                                                                                handleSummaryInputChange("summary", "award_date", value);
                                                                            }}
                                                                            className="radio-group-class"
                                                                        />
                                                                        <CalendarElement
                                                                            id="award_date"
                                                                            className='ml-10'
                                                                            defaultValue={parseDateString(opportunityDetails?.summary?.award_date?.text)}
                                                                            value={parseDateString(opportunityDetails?.summary?.award_date?.text)}
                                                                            onChange={(value) => {
                                                                                handleCalenderSummaryInputChange("summary", "award_date", formatDate(value.value));
                                                                            }}
                                                                            maxLength="50"
                                                                            placeholder="Date"
                                                                            autocomplete="off"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props?.summaryData?.projectSumFields, { field_name: "Project Start Date" })?.field_status &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "Project Start Date" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {
                                                                            customerTooltipData?.contract?.contract_start_date_summary.status == true &&
                                                                            <div>
                                                                                <Tooltip target=".custom-target-icon" />

                                                                                <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                    data-pr-tooltip={customerTooltipData?.contract.contract_start_date_summary?.text}
                                                                                    data-pr-position="right">
                                                                                </i>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    <div className='col pr-0 d-flex align-items-center'>
                                                                        <RadioElement
                                                                            id="start_date"
                                                                            options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
                                                                            value={opportunityDetails?.summary?.contract_start_date_summary?.radio}
                                                                            onChangeRadio={(value) => {
                                                                                handleSummaryInputChange("summary", "contract_start_date_summary", value);
                                                                            }}
                                                                            className="radio-group-class"
                                                                        />
                                                                        <CalendarElement
                                                                            id="start_date"
                                                                            className='ml-10'
                                                                            defaultValue={parseDateString(opportunityDetails?.summary?.contract_start_date_summary?.text)}
                                                                            value={parseDateString(opportunityDetails?.summary?.contract_start_date_summary?.text)}
                                                                            onChange={(value) => {
                                                                                handleCalenderSummaryInputChange("summary", "contract_start_date_summary", formatDate(value.value));
                                                                            }}
                                                                            maxLength="50"
                                                                            placeholder="Date"
                                                                            autocomplete="off"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props?.summaryData?.projectSumFields, { field_name: "Project End Date" })?.field_status &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "Project End Date" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {
                                                                            customerTooltipData?.contract?.contract_end_date_summary.status == true &&
                                                                            <div>
                                                                                <Tooltip target=".custom-target-icon" />

                                                                                <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                    data-pr-tooltip={customerTooltipData?.contract?.contract_end_date_summary?.text}
                                                                                    data-pr-position="right">
                                                                                </i>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    <div className='col pr-0 d-flex align-items-center'>
                                                                        <RadioElement
                                                                            id="end_date"
                                                                            options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
                                                                            value={opportunityDetails?.summary?.contract_end_date_summary?.radio}
                                                                            onChangeRadio={(value) => {
                                                                                handleSummaryInputChange("summary", "contract_end_date_summary", value);
                                                                            }}
                                                                            className="radio-group-class"
                                                                        />
                                                                        <CalendarElement
                                                                            id="end_date"
                                                                            className='ml-10'
                                                                            defaultValue={parseDateString(opportunityDetails?.summary?.contract_end_date_summary?.text)}
                                                                            value={parseDateString(opportunityDetails?.summary?.contract_end_date_summary?.text)}
                                                                            onChange={(value) => {
                                                                                handleCalenderSummaryInputChange("summary", "contract_end_date_summary", formatDate(value.value));
                                                                            }}
                                                                            maxLength="50"
                                                                            placeholder="Date"
                                                                            autocomplete="off"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props?.summaryData?.projectSumFields, { field_name: "Project Value" })?.field_status &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "Project Value" })?.display_name + ' (' + (currency ? currency : '£ ') + ')'}:</label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {
                                                                            customerTooltipData?.contract?.project_value_contract.status == true &&
                                                                            <div>
                                                                                <Tooltip target=".custom-target-icon" />

                                                                                <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                    data-pr-tooltip={customerTooltipData?.contract?.project_value_contract?.text}
                                                                                    data-pr-position="right">
                                                                                </i>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    <div className='col pr-0 d-flex align-items-center'>
                                                                        <RadioElement
                                                                            id="project_value_contract"
                                                                            options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
                                                                            value={opportunityDetails?.project_value_contract?.radio}
                                                                            onChangeRadio={(value) => {
                                                                                handleInputChange("project_value_contract", value);
                                                                            }}
                                                                            className="radio-group-class"
                                                                        />
                                                                        <Controller
                                                                            name="project_value_contract"
                                                                            control={control}
                                                                            defaultValue={opportunityDetails?.project_value_contract?.text}
                                                                            style={{ innerHeight: 10 }}
                                                                            render={({ field }) => {
                                                                                return (
                                                                                    <InputTextElementElement
                                                                                        defaultValue={opportunityDetails?.project_value_contract?.text}
                                                                                        placeholder="Amount"
                                                                                        name="project_value_contract"
                                                                                        className="w-full"
                                                                                        {...field}
                                                                                        onChange={(e) => {
                                                                                            const newValue = e.target.value;
                                                                                            handleCalenderInputChange("project_value_contract", newValue);
                                                                                            field.onChange(newValue);
                                                                                        }}
                                                                                    />
                                                                                );
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props?.summaryData?.projectFieldsNew, { field_name: "Estimated Contract Value" })?.field_status &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props?.summaryData?.projectFieldsNew, { field_name: "Estimated Contract Value" })?.display_name + ' (' + (currency ? currency : '£ ') + ')'}:</label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {
                                                                            customerTooltipData?.contract?.contract_value.status == true &&
                                                                            <div>
                                                                                <Tooltip target=".custom-target-icon" />

                                                                                <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                    data-pr-tooltip={customerTooltipData?.contract?.contract_value?.text}
                                                                                    data-pr-position="right">
                                                                                </i>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    <div className='col pr-0 d-flex align-items-center'>
                                                                        <RadioElement
                                                                            id="contract_value"
                                                                            options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
                                                                            value={opportunityDetails?.contract_value?.radio}
                                                                            onChangeRadio={(value) => {
                                                                                handleInputChange("contract_value", value);
                                                                            }}
                                                                            className="radio-group-class"
                                                                        />
                                                                        <Controller
                                                                            name="contract_value"
                                                                            control={control}
                                                                            defaultValue={opportunityDetails?.contract_value?.text}
                                                                            style={{ innerHeight: 10 }}
                                                                            render={({ field }) => {
                                                                                return (
                                                                                    <InputTextElementElement
                                                                                        defaultValue={opportunityDetails?.contract_value?.text}
                                                                                        placeholder="Amount"
                                                                                        name="contract_value"
                                                                                        className="w-full"
                                                                                        {...field}
                                                                                        onChange={(e) => {
                                                                                            const newValue = e.target.value;
                                                                                            calculateContract(newValue);
                                                                                            field.onChange(newValue);
                                                                                        }}
                                                                                    />
                                                                                );
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                        <div className="col-md-6 pl-0">
                                                            {
                                                                _.find(props?.summaryData?.projectSumFields, { field_name: "Contract Variation" })?.field_status &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "Contract Variation" })?.display_name + ' (' + (currency ? currency : '£ ') + ')'}:</label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {
                                                                            customerTooltipData?.contract?.contract_variation?.status == true &&
                                                                            <div>
                                                                                <Tooltip target=".custom-target-icon" />

                                                                                <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                    data-pr-tooltip={customerTooltipData?.contract?.contract_variation?.text}
                                                                                    data-pr-position="right">
                                                                                </i>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    <div className='col pr-0 d-flex align-items-center'>
                                                                        <Controller
                                                                            name="contract_variation"
                                                                            control={control}
                                                                            defaultValue={opportunityDetails?.contract_variation}
                                                                            style={{ innerHeight: 10 }}
                                                                            render={({ field }) => {
                                                                                return (
                                                                                    <InputTextElementElement
                                                                                        defaultValue={opportunityDetails?.contract_variation}
                                                                                        placeholder="Amount"
                                                                                        name="contract_variation"
                                                                                        className="w-full"
                                                                                        {...field}
                                                                                        onKeyDown={(e) => {
                                                                                            // Allow only numbers, backspace, delete, and decimal point
                                                                                            const allowedKeys = [
                                                                                                "Backspace",
                                                                                                "Tab",
                                                                                                "Delete",
                                                                                                "ArrowLeft",
                                                                                                "ArrowRight",
                                                                                                "ArrowUp",
                                                                                                "ArrowDown",
                                                                                            ];
                                                                                            if (
                                                                                                !/^\d$/.test(e.key) && // Numeric keys
                                                                                                e.key !== "." && // Allow decimal point
                                                                                                !allowedKeys.includes(e.key) // Allow navigation and control keys
                                                                                            ) {
                                                                                                e.preventDefault();
                                                                                            }
                                                                                        }}
                                                                                        onChange={(e) => {
                                                                                            const newValue = e.target.value;
                                                                                            calculateTotalContract(newValue);
                                                                                            setGlobalOpportunityData((prevData) => ({
                                                                                                ...prevData,
                                                                                                contract_variation: newValue
                                                                                            }));
                                                                                            field.onChange(newValue)
                                                                                        }}
                                                                                    // onChange={(e) => {
                                                                                    //     const newValue = e.target.value;
                                                                                    //     calculateTotalContract(newValue);
                                                                                    //     field.onChange(newValue);
                                                                                    // }}
                                                                                    />
                                                                                );
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props?.summaryData?.projectSumFields, { field_name: "Total Contract Value" })?.field_status &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "Total Contract Value" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        &nbsp;
                                                                    </div>
                                                                    <div className="col pl-0">
                                                                        <Controller
                                                                            name="total_contract_value"
                                                                            control={control}
                                                                            defaultValue={(currency ? currency : '£ ') + ' ' + (!isNaN(opportunityDetails?.total_contract_value?.text) ? (opportunityDetails?.total_contract_value?.text)?.toFixed(2) : 0)}
                                                                            style={{ innerHeight: 10 }}
                                                                            render={({ field }) => {
                                                                                return (
                                                                                    <div>
                                                                                        <label name='total_contract_value' className="form-label text-left">{(currency ? currency : '£ ') + ' ' + (!isNaN(opportunityDetails?.total_contract_value?.text) ? (opportunityDetails?.total_contract_value?.text)?.toFixed(2) : 0)}</label>
                                                                                    </div>
                                                                                );
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props?.summaryData?.projectSumFields, { field_name: "Margin Expected" })?.field_status &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "Margin Expected" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {
                                                                            customerTooltipData?.contract?.margin_expected.status == true &&
                                                                            <div>
                                                                                <Tooltip target=".custom-target-icon" />

                                                                                <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                    data-pr-tooltip={customerTooltipData?.contract?.margin_expected?.text}
                                                                                    data-pr-position="right">
                                                                                </i>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    <div className='col pr-0 d-flex align-items-center'>
                                                                        <RadioElement
                                                                            id="margin_expected_radio"
                                                                            options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
                                                                            value={opportunityDetails?.summary?.margin_expected?.radio}
                                                                            onChangeRadio={(value) => {
                                                                                handleSummaryInputChange("summary", "margin_expected", value);
                                                                            }}
                                                                            className="radio-group-class"
                                                                        />
                                                                        <Controller
                                                                            name="margin_expected_text"
                                                                            control={control}
                                                                            defaultValue={opportunityDetails?.summary?.margin_expected?.text}
                                                                            style={{ innerHeight: 10 }}
                                                                            render={({ field }) => {
                                                                                return (
                                                                                    <InputTextElementElement
                                                                                        defaultValue={opportunityDetails?.summary?.margin_expected?.text}
                                                                                        placeholder="Amount"
                                                                                        name="margin_expected_text"
                                                                                        className="w-full"
                                                                                        {...field}
                                                                                        onChange={(e) => {
                                                                                            const newValue = e.target.value;
                                                                                            handleMarginExpected(newValue);
                                                                                            field.onChange(e)
                                                                                        }}
                                                                                    />
                                                                                );
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props?.summaryData?.projectSumFields, { field_name: "Contract Variation Margin" })?.field_status &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "Contract Variation Margin" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {
                                                                            customerTooltipData?.contract?.contract_variation_margin?.status == true &&
                                                                            <div>
                                                                                <Tooltip target=".custom-target-icon" />

                                                                                <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                    data-pr-tooltip={customerTooltipData?.contract?.contract_variation_margin?.text}
                                                                                    data-pr-position="right">
                                                                                </i>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    <div className='col pr-0 d-flex align-items-center'>
                                                                        <Controller
                                                                            name="contract_variation_margin"
                                                                            control={control}
                                                                            defaultValue={opportunityDetails?.summary?.contract_variation_margin}
                                                                            style={{ innerHeight: 10 }}
                                                                            render={({ field }) => {
                                                                                return (
                                                                                    <InputTextElementElement
                                                                                        defaultValue={opportunityDetails?.summary?.contract_variation_margin}
                                                                                        placeholder="Amount"
                                                                                        name="contract_variation_margin"
                                                                                        className="w-full"
                                                                                        {...field}
                                                                                        onChange={(e) => {
                                                                                            const newValue = e.target.value;
                                                                                            handleContractMargin(newValue);
                                                                                            field.onChange(newValue);
                                                                                        }}
                                                                                    />
                                                                                );
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props?.summaryData?.projectSumFields, { field_name: "Total Contract Margin" })?.field_status &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "Total Contract Margin" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {
                                                                            customerTooltipData?.contract?.margin_expected.status == true &&
                                                                            <div>
                                                                                <Tooltip target=".custom-target-icon" />

                                                                                <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                    data-pr-tooltip={customerTooltipData?.contract?.margin_expected?.text}
                                                                                    data-pr-position="right">
                                                                                </i>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    <div className="col pl-0">
                                                                        &nbsp;
                                                                        <Controller
                                                                            name="contract_margin"
                                                                            control={control}
                                                                            defaultValue={(currency ? currency : '£ ') + ' ' + (!isNaN(opportunityDetails?.summary?.contract_margin) ? (opportunityDetails?.summary?.contract_margin)?.toFixed(2) : 0)}
                                                                            rules={{ required: "Should be less than 8 characters & Special Character is not allowed" }}
                                                                            style={{ innerHeight: 10 }}
                                                                            render={({ field }) => {
                                                                                return (
                                                                                    <div>
                                                                                        <label name="contract_margin" className="form-label text-left">{(currency ? currency : '£ ') + ' ' + (!isNaN(opportunityDetails?.summary?.contract_margin) ? (opportunityDetails?.summary?.contract_margin)?.toFixed(2) : 0)}</label>
                                                                                    </div>
                                                                                );
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props?.summaryData?.commanFieldsNew, { field_name: "Bid Cost Contribution" })?.field_status &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props?.summaryData?.commanFieldsNew, { field_name: "Bid Cost Contribution" })?.display_name + ' (' + (currency ? currency : '£ ') + ')'}:</label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {
                                                                            customerTooltipData?.contract?.bid_cost.status == true &&
                                                                            <div>
                                                                                <Tooltip target=".custom-target-icon" />
                                                                                <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                    data-pr-tooltip={customerTooltipData?.contract?.bid_cost?.text}
                                                                                    data-pr-position="right">
                                                                                </i>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    <div className='col pr-0 d-flex align-items-center'>
                                                                        <RadioElement
                                                                            id="bid_cost"
                                                                            options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
                                                                            value={opportunityDetails?.bid_cost?.radio}
                                                                            onChangeRadio={(value) => {
                                                                                handleInputChange("bid_cost", value);
                                                                            }}
                                                                            className="radio-group-class"
                                                                        />
                                                                        <InputTextElementElement
                                                                            defaultValue={opportunityDetails?.bid_cost?.text}
                                                                            placeholder="Amount"
                                                                            name="bid_cost"
                                                                            className="w-full"
                                                                            onChange={(e) => {
                                                                                setOpportunityDetails((prevData) => ({
                                                                                    ...prevData,
                                                                                    bid_cost: {
                                                                                        ...prevData.bid_cost,
                                                                                        text: e.target.value
                                                                                    }
                                                                                }));
                                                                            }
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props?.summaryData?.projectSumFields, { field_name: "Other Revenue" })?.field_status &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "Other Revenue" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                        {
                                                                            customerTooltipData?.contract?.other_revenue?.status == true &&
                                                                            <div>
                                                                                <Tooltip target=".custom-target-icon" />
                                                                                <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                    data-pr-tooltip={customerTooltipData?.contract?.other_revenue?.text}
                                                                                    data-pr-position="right">
                                                                                </i>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    <div className='col pr-0 d-flex align-items-center'>
                                                                        <RadioElement
                                                                            id="other_revenue"
                                                                            options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
                                                                            value={opportunityDetails?.other_revenue?.radio}
                                                                            onChangeRadio={(value) => {
                                                                                handleInputChange("other_revenue", value);
                                                                            }}
                                                                            className="radio-group-class"
                                                                        />
                                                                        <InputTextElementElement
                                                                            defaultValue={opportunityDetails?.other_revenue?.text}
                                                                            placeholder="Amount"
                                                                            name="margin_expected"
                                                                            className="w-full"
                                                                            onChange={(e) => {
                                                                                setGlobalOpportunityData((prevData) => ({
                                                                                    ...prevData,
                                                                                    other_revenue: {
                                                                                        ...prevData.other_revenue,
                                                                                        text: e.target.value
                                                                                    }
                                                                                }));
                                                                            }
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                key == 'obj5' &&
                                                <div className="new-field">
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className='col-md-6 pl-0'>
                                                            {
                                                                _.find(props?.summaryData?.commanFieldsNew, { field_name: "Internal Hours to Date" })?.field_status &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props?.summaryData?.commanFieldsNew, { field_name: "Internal Hours to Date" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{commercialData?.internalHours}&nbsp;{" hours"}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props?.summaryData?.commanFieldsNew, { field_name: "Internal Cost to Date" })?.field_status &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props?.summaryData?.commanFieldsNew, { field_name: "Internal Cost to Date" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{(currency ? currency : '£ ') + ' ' + (commercialData?.internalCost)}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props?.summaryData?.commanFieldsNew, { field_name: "External Cost to Date" })?.field_status &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props?.summaryData?.commanFieldsNew, { field_name: "External Cost to Date" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{(currency ? currency : '£') + ' ' + (commercialData?.externalCost)}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props?.summaryData?.commanFieldsNew, { field_name: "Bid Cost Contribution" })?.field_status &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props?.summaryData?.commanFieldsNew, { field_name: "Bid Cost Contribution" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{(currency ? currency : '£') + ' ' + (opportunityDetails?.bid_cost?.text)}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                        <div className='col-md-6 pl-0'>
                                                            {
                                                                _.find(props?.summaryData?.projectSumFields, { field_name: "Total Bid Cost to Date" })?.field_status &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "Total Bid Cost to Date" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <div className='col pr-0'>
                                                                            <label className="form-label text-left">{(currency ? currency : '£') + ' ' + (commercialData?.totalBidCost)}</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props?.summaryData?.projectSumFields, { field_name: "Bid Cost to Date as % of TCV" })?.field_status &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "Bid Cost to Date as % of TCV" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <div className='col pr-0'>
                                                                            <label className="form-label text-left">{(currency ? currency : '£') + ' ' + (commercialData?.BidCost_TCV)}</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props?.summaryData?.projectSumFields, { field_name: "Projected Bid Cost" })?.field_status &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props?.summaryData?.projectSumFields, { field_name: "Projected Bid Cost" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className="col-md-1 pl-0">
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <div className='col pr-0'>
                                                                            <label className="form-label text-left">{(currency ? currency : '£') + ' ' + (commercialData?.projected_bid_cost)}</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            
                                        </AccordionTab>
                                    }
                                </Accordion>
                            </div>
                        )
                        )}
                    <Dialog visible={showModal} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm Stop" modal footer={stopFooter()} onHide={handleCloseModal} className="table-dialog width-32" draggable={false}>
                        <div className="confirmation-content">
                            <span className="table-description">
                                Further Status changes will not be allowed by system
                            </span>
                        </div>
                    </Dialog>
                    <Dialog visible={projectNumAlertModal} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm Generate" modal footer={projectNumAlertFooter()} onHide={hideProjectNumAlertDialog} className="table-dialog width-32" draggable={false}>
                        <div className="confirmation-content">
                            <span className="table-description">
                                This action will generate the Project Number and changes will not be revert back. Do you want to proceed?
                            </span>
                        </div>
                    </Dialog>
                    <Dialog visible={bidTeamUpdateAlertModal} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm Save" modal footer={saveFooter()} onHide={handleSaveModal} className="table-dialog width-32" draggable={false}>
                        <div className="confirmation-content">
                            <span className="table-description">
                                This action will update the team. Do you want to proceed?
                            </span>
                        </div>
                    </Dialog>
                    <Dialog id="videoModal" visible={showVideo}
                        breakpoints={{
                            '1200px': '80vw',    // Larger modal on bigger screens
                            '1024px': '85vw',    // Slightly smaller for medium screens
                            '769': '90vw',     // Responsive on tablets
                            '641px': '95vw',     // Almost full-width on mobile
                        }}
                        modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
                    >
                        <div className="video-overlay">
                            <div className="video-container">
                                <PlaylistVideos playlistId={process.env.REACT_APP_PORTFOLIO_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="summary" />
                            </div>
                        </div>
                    </Dialog>
                </form>
            }
            {custDetails && custDetails?.customer_short && custDetails.customer_short !== process.env.REACT_APP_JMAN && custDetails.customer_short !== process.env.REACT_APP_VM && custDetails.customer_short !== process.env.REACT_APP_GSA && custDetails.customer_short !== process.env.REACT_APP_ASCENSOS && custDetails.customer_short !== process.env.REACT_APP_ESG_PREV && custDetails.customer_short !== process.env.REACT_APP_GCEK && custDetails.customer_short !== process.env.REACT_APP_NAYLOR && custDetails.customer_short !== process.env.REACT_APP_PUREPATH && custDetails.customer_short !== process.env.REACT_APP_ZEES && custDetails.customer_short !== process.env.REACT_APP_ZEE ? <div className="cancel-footer position-relative" style={{ top: "-1rem" }}            >
                <div className='d-flex align-center justify-end pb-0'>
                    <ButtonElement className="save-button" type="submit" label="Tender Document Review Report" onClick={generateTenderDocumentReport} />
                    <ButtonElement className="save-button ml-20" type="submit" label="Tender Sales Report" onClick={generateTenderReport} />
                </div>
            </div> : null
            }
        </div>
    );

})

export default Summary;